import { LOCALES, DEFAULT_LANG, langPrefix } from "@/i18n/locales";
import { Egg, Bird, Beef, Rabbit, Bug, PawPrint } from "lucide-react";

// Localized SEO landing pages per livestock type (8 species x 22 languages).
// Auto-generated (natural, species-specific, market vocabulary — not literal translations).
export const SPECIES_KEYS = ["poules","volailles","chevres","moutons","bovins","porcs","lapins","abeilles"];
export const SPECIES_ICON = { poules: Egg, volailles: Bird, chevres: PawPrint, moutons: PawPrint, bovins: Beef, porcs: PawPrint, lapins: Rabbit, abeilles: Bug };

export const SPECIES_SLUGS = {
  "poules": {
    "fr": "suivi-poules-pondeuses",
    "en": "laying-hen-management",
    "es": "gallinas-ponedoras-gestion",
    "it": "galline-ovaiole-gestione",
    "de": "legehennen-verwaltung",
    "nl": "legkippen-beheer",
    "sv": "varaktshons-hantering",
    "da": "aeglaeggende-hons-styring",
    "bg": "upravlenie-nosachki",
    "el": "diaxirisi-ornithonas",
    "hr": "upravljanje-nesicama",
    "et": "munakanade-haldamine",
    "fi": "munijakanat-hallinta",
    "hu": "tojotyluk-menedzsment",
    "lv": "dejkuru-vistas-parvaldiba",
    "lt": "desliniu-vistu-valdymas",
    "pl": "zarzadzanie-kurami-nioska",
    "pt": "galinhas-poedeiras-gestao",
    "ro": "gaini-ouatoare-management",
    "sk": "sliepky-nosnice-manazment",
    "sl": "nesnice-upravljanje-jajc",
    "cs": "nosnice-management-vajec"
  },
  "volailles": {
    "fr": "gestion-elevage-volailles",
    "en": "poultry-flock-management",
    "es": "gestion-lotes-aves-corral",
    "it": "gestione-allevamento-pollame",
    "de": "gefluegel-herden-management",
    "nl": "pluimvee-koppel-beheer",
    "sv": "fjaderfa-flockhantering",
    "da": "fjerkrae-flok-styring",
    "bg": "upravlenie-ptitsi-grupi",
    "el": "diaxeirisi-ptinotrofias",
    "hr": "upravljanje-peradarskim-jatima",
    "et": "linnukasvatuse-partii-haldus",
    "fi": "siipikarjan-parvi-hallinta",
    "hu": "baromfi-csapat-kezeles",
    "lv": "majputnu-baru-parvaldiba",
    "lt": "naminiu-pauksciu-bandu-valdymas",
    "pl": "zarzadzanie-stadem-drobiu",
    "pt": "gestao-lotes-aves-producao",
    "ro": "gestionare-loturi-pasari-curte",
    "sk": "sprava-hydiny-sarze",
    "sl": "upravljanje-jat-perjadi",
    "cs": "sprava-hejn-hydiny"
  },
  "chevres": {
    "fr": "gestion-elevage-chevres",
    "en": "goat-herd-management",
    "es": "gestion-rebano-cabras",
    "it": "gestione-allevamento-capre",
    "de": "ziegen-herde-verwalten",
    "nl": "geitenbedrijf-beheren",
    "sv": "getbesattning-hantering",
    "da": "gedebesaetning-styring",
    "bg": "otgleždane-kozi",
    "el": "diacheirisi-katsikon",
    "hr": "uzgoj-koza-upravljanje",
    "et": "kitsede-kari-haldamine",
    "fi": "vuohilauman-hallinta",
    "hu": "kecske-allomany-kezeles",
    "lv": "kazu-ganampulka-parvaldiba",
    "lt": "oziu-banda-valdymas",
    "pl": "hodowla-koz-zarzadzanie",
    "pt": "gestao-rebanho-cabras",
    "ro": "crestere-capre-ferma",
    "sk": "chov-koz-sprava",
    "sl": "reja-koz-upravljanje",
    "cs": "chov-koz-sprava"
  },
  "moutons": {
    "fr": "gestion-elevage-moutons",
    "en": "sheep-flock-management",
    "es": "gestion-ganado-ovino",
    "it": "gestione-allevamento-ovini",
    "de": "schafherde-verwaltung",
    "nl": "schaapskudde-beheer",
    "sv": "fårbesättning-hantering",
    "da": "faareflock-styring",
    "bg": "upravlenie-ovtse-stado",
    "el": "diaxeirisi-kopadou-provaton",
    "hr": "upravljanje-stadom-ovaca",
    "et": "lammaste-kari-haldamine",
    "fi": "lammaslauman-hallinta",
    "hu": "juhnyaj-kezeles-szoftver",
    "lv": "aitu-bara-parvaldiba",
    "lt": "aviu-banda-valdymas",
    "pl": "zarzadzanie-stadem-owiec",
    "pt": "gestao-rebanho-ovinos",
    "ro": "gestionare-turma-ovine",
    "sk": "sprava-stada-oviec",
    "sl": "upravljanje-trop-ovac",
    "cs": "sprava-stada-ovci"
  },
  "bovins": {
    "fr": "gestion-elevage-bovin",
    "en": "cattle-herd-management",
    "es": "gestion-ganado-bovino",
    "it": "gestione-allevamento-bovino",
    "de": "rinderhaltung-verwaltung",
    "nl": "rundvee-beheer-software",
    "sv": "notkreatur-besattning",
    "da": "kvaeg-besaetning-styring",
    "bg": "upravlenie-goveda-ferma",
    "el": "diaxeirisi-vooeidon-zoion",
    "hr": "upravljanje-govedarstvo",
    "et": "veisekasvatus-haldus",
    "fi": "nautakarjan-hallinta",
    "hu": "szarvasmarha-tarto-szoftver",
    "lv": "liellopu-audzesanas-vadiba",
    "lt": "galviju-ukio-valdymas",
    "pl": "zarzadzanie-hodowla-bydla",
    "pt": "gestao-bovinos-leite-carne",
    "ro": "gestionare-bovine-ferma",
    "sk": "chov-hovadziho-dobytka",
    "sl": "reja-govedi-upravljanje",
    "cs": "chov-skotu-sprava"
  },
  "porcs": {
    "fr": "gestion-elevage-porcs",
    "en": "pig-farm-management",
    "es": "gestion-granja-porcina",
    "it": "gestione-allevamento-suini",
    "de": "schweinehaltung-software",
    "nl": "varkenshouderij-beheer",
    "sv": "grisuppfodning-programvara",
    "da": "svineproduktion-software",
    "bg": "upravlenie-svineferma",
    "el": "diaxeirisi-xoirotrофias",
    "hr": "upravljanje-svinjogojstvom",
    "et": "seakasvatus-tarkvara",
    "fi": "sianlihaturotanto-hallinta",
    "hu": "sertes-telep-kezeles",
    "lv": "cukaudzesana-programma",
    "lt": "kiauliu-ukio-valdymas",
    "pl": "hodowla-swin-zarzadzanie",
    "pt": "gestao-suinocultura",
    "ro": "gestionare-ferma-porcine",
    "sk": "chov-osipanych-sprava",
    "sl": "reja-prasicev-upravljanje",
    "cs": "chov-prasat-sprava"
  },
  "lapins": {
    "fr": "gestion-elevage-lapins",
    "en": "rabbit-farm-management",
    "es": "gestion-cria-conejos",
    "it": "gestione-allevamento-conigli",
    "de": "kaninchen-zucht-verwaltung",
    "nl": "konijnen-fokkerij-beheer",
    "sv": "kanin-uppfodning-system",
    "da": "kanin-opdraet-styring",
    "bg": "upravlenie-otgleждane-zaytsi",
    "el": "diaxeirisi-ektrофis-kounelion",
    "hr": "upravljanje-uzgojem-kunića",
    "et": "kulude-janikulasvatus",
    "fi": "kaninkasvatus-hallinta",
    "hu": "nyultenyesztes-menedzsment",
    "lv": "trušu-audzēšanas-pārvaldība",
    "lt": "triušių-auginimo-valdymas",
    "pl": "hodowla-krolikow-zarzadzanie",
    "pt": "gestao-criacao-coelhos",
    "ro": "gestionare-crestere-iepuri",
    "sk": "chov-kralikov-sprava",
    "sl": "reja-kuncev-upravljanje",
    "cs": "chov-kraliku-sprava"
  },
  "abeilles": {
    "fr": "gestion-apiculture-ruches",
    "en": "beekeeping-hive-management",
    "es": "gestion-colmenas-apicultura",
    "it": "gestione-apiario-alveari",
    "de": "bienenhaltung-beuten-verwaltung",
    "nl": "bijenhouden-bijenkorven-beheer",
    "sv": "biodling-bikupor-hantering",
    "da": "biavl-bistader-styring",
    "bg": "pчelarstvo-upravlenie-kosheri",
    "el": "melitokomia-diaxeirisi-kivotia",
    "hr": "pcelarstvo-upravljanje-kosnicama",
    "et": "mesindus-tarupidamine-haldus",
    "fi": "mehilaishoito-pesien-hallinta",
    "hu": "meheszet-kaptarkezeles-nyilvantartas",
    "lv": "biškopiba-stropu-parvaldiba",
    "lt": "bitynas-avilio-valdymas",
    "pl": "pszczelarstwo-zarzadzanie-ulami",
    "pt": "apicultura-gestao-colmeias",
    "ro": "apicultura-gestionare-stupi",
    "sk": "vcelarstvo-sprava-ulikov",
    "sl": "cebelarstvo-upravljanje-panjev",
    "cs": "vcelarstvi-sprava-ulu"
  }
};

export const SPECIES_CONTENT = {
  "poules": {
    "fr": {
      "title": "Poules pondeuses – Gestion simplifiée | Ma Petite Ferme",
      "description": "Suivez la ponte, les taux de production et la santé de vos poules pondeuses avec Ma Petite Ferme. Optimisez votre élevage et maximisez vos rendements en œufs.",
      "h1": "Gérez vos poules pondeuses efficacement",
      "intro": "Ma Petite Ferme centralise toutes les données de votre poulailler pour un suivi précis de chaque lot. Analysez vos taux de ponte et prenez les bonnes décisions au bon moment.",
      "bullets": [
        "Enregistrez chaque récolte d'œufs par poulailler facilement",
        "Visualisez les taux de ponte semaine après semaine",
        "Détectez les baisses de production avant qu'elles s'aggravent"
      ]
    },
    "en": {
      "title": "Laying Hen Flock Tracking | Ma Petite Ferme",
      "description": "Track egg production, laying rates and flock health with Ma Petite Ferme. Smart henhouse management software built for serious poultry farmers and egg producers.",
      "h1": "Smarter management for laying hens",
      "intro": "Ma Petite Ferme gives egg farmers a clear, real-time picture of every henhouse's performance. Log daily egg counts, monitor laying rates, and act fast when production dips.",
      "bullets": [
        "Record daily egg harvests per henhouse in seconds",
        "Track laying rate trends across your entire flock",
        "Get alerts when production drops below your targets"
      ]
    },
    "es": {
      "title": "Gestión de Gallinas Ponedoras | Ma Petite Ferme",
      "description": "Controla la producción de huevos, tasas de puesta y salud del gallinero con Ma Petite Ferme. El software ideal para avicultores y productores de huevos profesionales.",
      "h1": "Controla tu gallinero con precisión",
      "intro": "Ma Petite Ferme te permite registrar cada recolecta de huevos y analizar el rendimiento de tus gallinas ponedoras en tiempo real. Toma decisiones informadas para mejorar la rentabilidad de tu granja.",
      "bullets": [
        "Registra la recolecta diaria de huevos por gallinero",
        "Analiza la tasa de puesta por lote y por semana",
        "Detecta caídas de producción y actúa rápidamente"
      ]
    },
    "it": {
      "title": "Gestione Galline Ovaiole | Ma Petite Ferme",
      "description": "Monitora la produzione di uova, i tassi di deposizione e la salute del pollaio con Ma Petite Ferme. Il software perfetto per gli allevatori di galline ovaiole professionisti.",
      "h1": "Gestisci le tue galline ovaiole con facilità",
      "intro": "Ma Petite Ferme ti offre uno strumento completo per tenere traccia di ogni raccolta di uova e monitorare le performance del tuo pollaio. Ottimizza la produzione e aumenta la redditività del tuo allevamento.",
      "bullets": [
        "Registra ogni raccolta di uova per pollaio in pochi click",
        "Monitora il tasso di deposizione settimana per settimana",
        "Identifica i cali di produzione prima che diventino critici"
      ]
    },
    "de": {
      "title": "Legehennen-Management leicht gemacht | Ma Petite Ferme",
      "description": "Verfolgen Sie Eierproduktion, Legeleistung und Herdengesundheit mit Ma Petite Ferme. Die smarte Stalllösung für Geflügelhalter und professionelle Eierproduzenten in Deutschland.",
      "h1": "Legehennen effizient verwalten und optimieren",
      "intro": "Ma Petite Ferme bietet Ihnen eine zentrale Plattform, um Eierernten zu erfassen und die Legeleistung jedes Stalls im Blick zu behalten. Reagieren Sie frühzeitig auf Produktionsschwankungen und steigern Sie Ihren Betriebsertrag.",
      "bullets": [
        "Tägliche Eierernte je Stall sekundenschnell erfassen",
        "Legeleistung pro Herde und Woche übersichtlich verfolgen",
        "Produktionsrückgänge frühzeitig erkennen und gegensteuern"
      ]
    },
    "nl": {
      "title": "Legkippen Beheer & Eiproductie | Ma Petite Ferme",
      "description": "Volg eiproductie, legpercentages en koppelgezondheid met Ma Petite Ferme. Slimme software voor legkippenhouders die hun stal efficiënter willen beheren en meer eieren willen rapen.",
      "h1": "Beheer uw legkippen slim en eenvoudig",
      "intro": "Ma Petite Ferme helpt pluimveehouders om dagelijkse eirapen bij te houden en de legprestaties per stal te bewaken. Ontdek trends, voorkom productieverliezen en optimaliseer uw bedrijfsresultaat.",
      "bullets": [
        "Dagelijkse eirapen per stal snel registreren",
        "Legpercentage per koppel wekelijks analyseren",
        "Productiedalingen vroegtijdig signaleren en aanpakken"
      ]
    },
    "sv": {
      "title": "Hantering av Värphöns & Äggproduktion | Ma Petite Ferme",
      "description": "Spåra äggproduktion, värpningsgrad och flockhälsa med Ma Petite Ferme. Smarta verktyg för svenska fjäderfäbönder som vill optimera sitt hönshus och öka lönsamheten.",
      "h1": "Optimera ditt hönshus med Ma Petite Ferme",
      "intro": "Ma Petite Ferme ger dig en tydlig överblick över äggproduktionen i varje hönshus och hjälper dig att följa värpningsgraden över tid. Reagera snabbt på produktionsförändringar och fatta välgrundade beslut för din gård.",
      "bullets": [
        "Registrera daglig äggplockning per hönshus enkelt",
        "Följ värpningsgraden vecka för vecka per flock",
        "Upptäck produktionsfall innan de påverkar lönsamheten"
      ]
    },
    "da": {
      "title": "Styring af Æglæggende Høns | Ma Petite Ferme",
      "description": "Registrer æggproduktion, lægningsrater og flokkes sundhed med Ma Petite Ferme. Det smarte redskab til danske fjerkræavlere der vil have styr på hønsehuset og maksimere udbyttet.",
      "h1": "Styr dit hønsehus med præcision",
      "intro": "Ma Petite Ferme giver dig et komplet overblik over ægproduktionen i hvert hønsehus og gør det nemt at følge lægningsraten over tid. Opdage produktionsfald hurtigt og træf de rigtige beslutninger for din bedrift.",
      "bullets": [
        "Log daglig ægindsamling per hønsehus på sekunder",
        "Følg lægningsraten per flok uge for uge",
        "Få advarsler ved fald i produktionen under målsætning"
      ]
    },
    "bg": {
      "title": "Управление на Носачки и Яйца | Ma Petite Ferme",
      "description": "Проследявайте производството на яйца, нивата на носливост и здравето на стадото с Ma Petite Ferme. Идеалният софтуер за птицевъди и производители на яйца в България.",
      "h1": "Управлявайте носачките си по-ефективно",
      "intro": "Ma Petite Ferme ви предоставя централизирана платформа за записване на всяка яйценосна реколта и наблюдение на продуктивността на всеки кокошарник. Вземайте навременни решения и увеличавайте рентабилността на фермата си.",
      "bullets": [
        "Записвайте дневната реколта на яйца по кокошарник",
        "Следете процента на носливост седмично по стадо",
        "Откривайте спадовете в производството навреме"
      ]
    },
    "el": {
      "title": "Διαχείριση Ορνιθώνα & Παραγωγής | Ma Petite Ferme",
      "description": "Παρακολουθήστε την παραγωγή αυγών, τα ποσοστά ωοτοκίας και την υγεία του κοπαδιού με Ma Petite Ferme. Το ιδανικό λογισμικό για Έλληνες πτηνοτρόφους και παραγωγούς αυγών.",
      "h1": "Διαχειριστείτε τον ορνιθώνα σας αποτελεσματικά",
      "intro": "Το Ma Petite Ferme σας δίνει πλήρη εικόνα της παραγωγής αυγών σε κάθε ορνιθώνα και σας βοηθά να παρακολουθείτε τα ποσοστά ωοτοκίας ανά εποχή. Εντοπίστε πτώσεις παραγωγής έγκαιρα και βελτιώστε την αποδοτικότητα της εκτροφής σας.",
      "bullets": [
        "Καταγράψτε την ημερήσια συγκομιδή αυγών ανά ορνιθώνα",
        "Παρακολουθήστε το ποσοστό ωοτοκίας εβδομαδιαία",
        "Εντοπίστε πτώσεις παραγωγής πριν επηρεάσουν τα έσοδα"
      ]
    },
    "hr": {
      "title": "Upravljanje Nesicama i Jajetom | Ma Petite Ferme",
      "description": "Pratite proizvodnju jaja, stope nošenja i zdravlje jata s Ma Petite Ferme. Pametni softver za hrvatske uzgajivače peradi koji žele optimizirati kokošinjac i povećati prinos.",
      "h1": "Upravljajte nesicama jednostavno i učinkovito",
      "intro": "Ma Petite Ferme nudi vam centralizirani pregled proizvodnje jaja u svakom kokošinjcu i pomaže vam pratiti stopu nošenja kroz cijelu godinu. Otkrijte padove u proizvodnji na vrijeme i donosite prave odluke za svoju farmu.",
      "bullets": [
        "Evidentirajte dnevnu berbu jaja po kokošinjcu brzo",
        "Pratite stopu nošenja po jatu i tjednu pregledno",
        "Otkrijte pad proizvodnje prije nego postane problem"
      ]
    },
    "et": {
      "title": "Munakanade Tootmise Haldamine | Ma Petite Ferme",
      "description": "Jälgige munatootmist, munemismäärasid ja karja tervist Ma Petite Ferme'iga. Nutikas tarkvara Eesti linnukasvatajatele, kes soovivad kanala tõhusust ja kasumlikkust suurendada.",
      "h1": "Halda munakanade tootmist nutikalt",
      "intro": "Ma Petite Ferme annab teile täieliku ülevaate iga kanala munatoodangust ja aitab jälgida munemismäärasid aastaringselt. Avastage tootmislangused varakult ja tehke teadlikke otsuseid oma talu paremaks juhtimiseks.",
      "bullets": [
        "Registreerige päevane munade koristus kanala kaupa",
        "Jälgige munemismäära nädalate kaupa karja kohta",
        "Tuvastage tootmislangused enne kasumi vähenemist"
      ]
    },
    "fi": {
      "title": "Munijakanalan Tuotannon Hallinta | Ma Petite Ferme",
      "description": "Seuraa munantuotantoa, munintaprosentteja ja lauman terveyttä Ma Petite Ferme -ohjelmistolla. Täydellinen työkalu suomalaisille siipikarjankasvattajille ja kananmunantuottajille.",
      "h1": "Hallinnoi munijakanalaasi tehokkaasti",
      "intro": "Ma Petite Ferme tarjoaa siipikarja-ammattilaisille selkeän kokonaiskuvan jokaisen kanalan munantuotannosta ja munintaprosenteista. Havaitse tuotannon laskut ajoissa ja tee oikeita päätöksiä tilasi kannattavuuden parantamiseksi.",
      "bullets": [
        "Kirjaa päivittäinen munien keruu kanalakohtaisesti nopeasti",
        "Seuraa munintaprosenttia viikottain lauman mukaan",
        "Tunnista tuotantolaskut ennen kuin ne heikentävät tulosta"
      ]
    },
    "hu": {
      "title": "Tojótyúk-tartás és Tojástermelés | Ma Petite Ferme",
      "description": "Kövesse nyomon a tojástermelést, a tojási arányokat és az állomány egészségét a Ma Petite Ferme segítségével. Okos szoftver magyar baromfitenyésztőknek és tojástermelőknek.",
      "h1": "Kezelje tojótyúkjait hatékonyan és okosan",
      "intro": "A Ma Petite Ferme átfogó képet nyújt minden ól tojástermeléséről, és segít nyomon követni a tojási arányokat az egész éven át. Ismerje fel időben a termeléscsökkenéseket, és hozzon megalapozott döntéseket farmja jövedelmezősége érdekében.",
      "bullets": [
        "Rögzítse a napi tojásgyűjtést ólankénti bontásban gyorsan",
        "Kövesse a tojási arányt hetente állományonként pontosan",
        "Észlelje a termeléscsökkenést mielőtt bevételkiesést okoz"
      ]
    },
    "lv": {
      "title": "Dējējvistu Olu Ražošanas Pārvaldība | Ma Petite Ferme",
      "description": "Sekojiet olu ražošanai, dēšanas rādītājiem un bara veselībai ar Ma Petite Ferme. Ideāls risinājums Latvijas mājputnu audzētājiem un olu ražotājiem.",
      "h1": "Pārvaldiet dējējvistas viegli un efektīvi",
      "intro": "Ma Petite Ferme nodrošina jums pilnīgu pārskatu par olu ražošanu katrā vistuvē un palīdz izsekot dēšanas rādītājiem visu gadu. Atklājiet ražošanas kritienus savlaicīgi un pieņemiet pamatotus lēmumus savas saimniecības attīstībai.",
      "bullets": [
        "Reģistrējiet ikdienas olu novākšanu katrā vistuvē ātri",
        "Sekojiet dēšanas rādītājiem nedēļu no nedēļas precīzi",
        "Atklājiet ražošanas kritienus pirms tie ietekmē peļņu"
      ]
    },
    "lt": {
      "title": "Dėsliųjų Vištų ir Kiaušinių Valdymas | Ma Petite Ferme",
      "description": "Stebėkite kiaušinių gamybą, dėjimo rodiklius ir bandos sveikatą su Ma Petite Ferme. Išmanus įrankis Lietuvos paukštininkams ir kiaušinių gamintojams.",
      "h1": "Valdykite dėsliąsias vištas efektyviai",
      "intro": "Ma Petite Ferme suteikia jums išsamų vaizdą apie kiaušinių gamybą kiekviename vištidėje ir padeda stebėti dėjimo rodiklius ištisus metus. Laiku aptinkite gamybos sumažėjimą ir priimkite pagrįstus sprendimus ūkio pelningumui gerinti.",
      "bullets": [
        "Registruokite kasdienį kiaušinių rinkimą vištidės lygmeniu",
        "Stebėkite dėjimo rodiklius kas savaitę pagal bandą",
        "Aptinkite gamybos mažėjimą prieš pajamas prarandant"
      ]
    },
    "pl": {
      "title": "Zarządzanie Kurami Nioskami i Jajami | Ma Petite Ferme",
      "description": "Śledź produkcję jaj, wskaźniki nieśności i zdrowie stada z Ma Petite Ferme. Inteligentne oprogramowanie dla polskich hodowców drobiu i producentów jaj kurzych.",
      "h1": "Zarządzaj kurami nioskami profesjonalnie",
      "intro": "Ma Petite Ferme daje Ci pełny wgląd w produkcję jaj każdego kurnika i pomaga monitorować wskaźniki nieśności przez cały rok. Wykryj spadki produkcji na czas i podejmuj trafne decyzje, by zwiększyć rentowność swojego gospodarstwa.",
      "bullets": [
        "Rejestruj dzienne zbiory jaj dla każdego kurnika szybko",
        "Śledź wskaźnik nieśności tygodniowo dla każdego stada",
        "Wykrywaj spadki produkcji zanim wpłyną na dochody"
      ]
    },
    "pt": {
      "title": "Gestão de Galinhas Poedeiras | Ma Petite Ferme",
      "description": "Acompanhe a produção de ovos, taxas de postura e saúde do lote com Ma Petite Ferme. O software ideal para avicultores e produtores de ovos que querem otimizar o galinheiro.",
      "h1": "Gira o seu galinheiro com mais eficiência",
      "intro": "O Ma Petite Ferme centraliza toda a informação do seu galinheiro, permitindo registar as recolhas de ovos e acompanhar as taxas de postura em tempo real. Identifique quebras de produção antecipadamente e tome decisões que aumentam a rentabilidade da sua exploração.",
      "bullets": [
        "Registe a recolha diária de ovos por galinheiro facilmente",
        "Analise a taxa de postura semanal por lote de galinhas",
        "Detete quebras de produção antes de afetarem os lucros"
      ]
    },
    "ro": {
      "title": "Management Găini Ouătoare și Ouă | Ma Petite Ferme",
      "description": "Urmăriți producția de ouă, ratele de ouat și sănătatea efectivului cu Ma Petite Ferme. Soluția ideală pentru crescătorii români de păsări și producătorii de ouă.",
      "h1": "Gestionați găinile ouătoare eficient",
      "intro": "Ma Petite Ferme vă oferă o imagine completă asupra producției de ouă din fiecare adăpost și vă ajută să monitorizați ratele de ouat pe tot parcursul anului. Depistați scăderile de producție la timp și luați decizii informate pentru rentabilitatea fermei dvs.",
      "bullets": [
        "Înregistrați colectarea zilnică a ouălor pe adăpost rapid",
        "Urmăriți rata de ouat săptămânal pe efectiv de găini",
        "Detectați scăderile de producție înainte să afecteze profitul"
      ]
    },
    "sk": {
      "title": "Manažment Sliepok Nosníc a Vajec | Ma Petite Ferme",
      "description": "Sledujte produkciu vajec, miery znášky a zdravie stáda s Ma Petite Ferme. Inteligentný softvér pre slovenských chovateľov hydiny a producentov vajec každej veľkosti.",
      "h1": "Spravujte sliepky nosnice efektívne",
      "intro": "Ma Petite Ferme vám poskytuje úplný prehľad o produkcii vajec v každom kurínku a pomáha sledovať miery znášky počas celého roka. Včas odhaľte poklesy v produkcii a robte správne rozhodnutia pre ziskovosť vašej farmy.",
      "bullets": [
        "Zaznamenávajte dennú zbierku vajec podľa kurínka rýchlo",
        "Sledujte mieru znášky týždenne pre každé stádo presne",
        "Odhaľte pokles produkcie skôr, ako ovplyvní príjmy"
      ]
    },
    "sl": {
      "title": "Upravljanje Nesnic in Pridelave Jajc | Ma Petite Ferme",
      "description": "Sledite pridelavi jajc, stopnji nesnosti in zdravju jate z Ma Petite Ferme. Pametna rešitev za slovenske rejce perutnine in pridelovalce jajc, ki želijo optimizirati hlev.",
      "h1": "Upravljajte nesnice preprosto in učinkovito",
      "intro": "Ma Petite Ferme vam zagotavlja celovit pregled nad pridelavo jajc v vsakem kokošnjaku in pomaga spremljati stopnje nesnosti skozi vse leto. Pravočasno zaznajte padce v pridelavi in sprejemajte odločitve, ki povečujejo donosnost vaše kmetije.",
      "bullets": [
        "Beležite dnevno pobiranje jajc po kokošnjaku hitro",
        "Spremljajte stopnjo nesnosti tedensko po jati pregledno",
        "Zaznajte padce pridelave preden vplivajo na dobiček"
      ]
    },
    "cs": {
      "title": "Správa Nosnic a Produkce Vajec | Ma Petite Ferme",
      "description": "Sledujte produkci vajec, míru snůšky a zdraví hejna s Ma Petite Ferme. Chytrý software pro české chovatele drůbeže a producenty vajec, kteří chtějí optimalizovat kurník.",
      "h1": "Spravujte nosnice efektivně a přehledně",
      "intro": "Ma Petite Ferme vám poskytuje kompletní přehled o produkci vajec v každém kurníku a pomáhá sledovat míru snůšky po celý rok. Včas odhalte poklesy produkce a přijímejte správná rozhodnutí pro ziskovost vaší farmy.",
      "bullets": [
        "Zaznamenávejte denní sběr vajec podle kurníku snadno",
        "Sledujte míru snůšky týdně pro každé hejno přehledně",
        "Odhalte pokles produkce dříve, než ovlivní vaše příjmy"
      ]
    }
  },
  "volailles": {
    "fr": {
      "title": "Suivi volailles & dindes – Ma Petite Ferme",
      "description": "Gérez vos lots de poulets, canards, oies et dindes avec Ma Petite Ferme. Suivez la croissance, la mortalité et optimisez chaque cycle d'élevage facilement.",
      "h1": "Pilotez vos lots de volailles simplement",
      "intro": "Ma Petite Ferme centralise le suivi de vos bandes de broilers, canards, oies et dindes en un seul tableau de bord intuitif. Anticipez les pertes, contrôlez la croissance et améliorez vos marges à chaque cycle.",
      "bullets": [
        "Suivi quotidien de la mortalité par lot et espèce",
        "Courbes de croissance comparées aux objectifs du cahier des charges",
        "Alertes automatiques sur les écarts de consommation d'aliments"
      ]
    },
    "en": {
      "title": "Poultry & Turkey Management – Ma Petite Ferme",
      "description": "Track broilers, ducks, geese and turkeys with Ma Petite Ferme. Monitor batch growth, mortality rates and feed efficiency to boost every production cycle.",
      "h1": "Smarter flock management for poultry breeders",
      "intro": "Ma Petite Ferme gives poultry farmers a clear, real-time view of every batch — from day-old chicks to market-ready birds. Reduce mortality, hit weight targets and make data-driven decisions with ease.",
      "bullets": [
        "Daily mortality logging per batch and poultry species",
        "Live weight tracking versus breed performance benchmarks",
        "Feed conversion ratio alerts to cut production costs"
      ]
    },
    "es": {
      "title": "Gestión de aves de corral – Ma Petite Ferme",
      "description": "Controla tus lotes de pollos, patos, ocas y pavos con Ma Petite Ferme. Registra crecimiento, mortalidad y conversión alimenticia para maximizar cada ciclo productivo.",
      "h1": "Controla tus lotes avícolas con precisión",
      "intro": "Ma Petite Ferme te permite gestionar cada lote de broilers, patos, ocas y pavos desde una sola plataforma sencilla y potente. Reduce bajas, mejora el índice de conversión y cumple tus objetivos de peso en cada ciclo.",
      "bullets": [
        "Registro diario de mortalidad por lote y especie avícola",
        "Seguimiento del peso vivo frente a estándares de la raza",
        "Alertas de consumo de pienso para reducir costes productivos"
      ]
    },
    "it": {
      "title": "Gestione pollame e tacchini – Ma Petite Ferme",
      "description": "Monitora lotti di broiler, anatre, oche e tacchini con Ma Petite Ferme. Tieni sotto controllo crescita, mortalità e conversione alimentare per ogni ciclo produttivo.",
      "h1": "Gestisci i tuoi lotti di pollame con precisione",
      "intro": "Ma Petite Ferme raccoglie in un unico cruscotto tutti i dati dei tuoi lotti avicoli, dai pulcini d'un giorno agli animali pronti alla vendita. Ottimizza la resa, riduci le perdite e rispetta i piani di accrescimento prefissati.",
      "bullets": [
        "Registrazione giornaliera della mortalità per lotto e specie",
        "Grafici di accrescimento a confronto con gli obiettivi aziendali",
        "Alert sull'indice di conversione per ridurre i costi di mangime"
      ]
    },
    "de": {
      "title": "Geflügel & Puten verwalten – Ma Petite Ferme",
      "description": "Verwalten Sie Masthähnchen-, Enten-, Gänse- und Putenchargen mit Ma Petite Ferme. Wachstum, Verluste und Futterverbrauch immer im Blick – für jeden Produktionszyklus.",
      "h1": "Geflügelherden effizient überwachen und steuern",
      "intro": "Ma Petite Ferme bietet Geflügelhaltern ein zentrales Dashboard für alle Chargen – von Masthähnchen über Enten und Gänse bis hin zu Puten. Reduzieren Sie Verluste, kontrollieren Sie Gewichtszunahmen und verbessern Sie Ihre Futterverwertung nachhaltig.",
      "bullets": [
        "Tägliche Verlusteerfassung je Charge und Geflügelart",
        "Gewichtsverlaufskurven im Vergleich zu Rassestandards",
        "Automatische Warnmeldungen bei auffälligem Futterverbrauch"
      ]
    },
    "nl": {
      "title": "Pluimvee & kalkoenen beheren – Ma Petite Ferme",
      "description": "Beheer koppels vleeskuikens, eenden, ganzen en kalkoenen met Ma Petite Ferme. Volg groei, uitval en voerconversie nauwkeurig voor elk productiecyclus.",
      "h1": "Beheer elk pluimveekoppel efficiënt",
      "intro": "Ma Petite Ferme biedt pluimveehouders één overzichtelijk platform voor alle koppels, van vleeskuikens tot kalkoenen. Stuur bij op uitval, bewaker groeidoelen en verlaag voerkosten met slimme data-inzichten.",
      "bullets": [
        "Dagelijkse uitvalregistratie per koppel en pluimveesoort",
        "Groeicurves vergeleken met ras- en contractnormen",
        "Voerconversiewaarschuwingen om productiekosten te verlagen"
      ]
    },
    "sv": {
      "title": "Hantera fjäderfä & kalkoner – Ma Petite Ferme",
      "description": "Följ upp flockar av slaktkycklingar, ankor, gäss och kalkoner med Ma Petite Ferme. Kontrollera tillväxt, dödlighet och fodereffektivitet i varje produktionscykel.",
      "h1": "Effektiv flock­hantering för fjäderfä­uppfödare",
      "intro": "Ma Petite Ferme samlar all data för dina fjäderfäflockar – slaktkycklingar, ankor, gäss och kalkoner – i en och samma plattform. Minska dödlighet, nå viktmål och optimera foderkonvertering med realtidsdata.",
      "bullets": [
        "Daglig dödlighetsregistrering per flock och art",
        "Tillväxtkurvor jämförda med rasspecifika riktmärken",
        "Automatiska varningar vid avvikande foderkonsumtion"
      ]
    },
    "da": {
      "title": "Fjerkræ & kalkuner – Ma Petite Ferme",
      "description": "Styr hold af slagtekyllinger, ænder, gæs og kalkuner med Ma Petite Ferme. Følg vækst, dødelighed og fodereffektivitet og optimer hvert produktionsforløb.",
      "h1": "Styr dine fjerkræhold præcist og nemt",
      "intro": "Ma Petite Ferme giver fjerkræavlere ét samlet overblik over alle hold – fra dag gamle kyllinger til slagtefærdige fugle. Reducer tab, hold styr på vækstmål og træf datadrevne beslutninger i tide.",
      "bullets": [
        "Daglig registrering af dødelighed pr. hold og art",
        "Vækstgrafer sammenlignet med racens standarder",
        "Advarsler om foderkonvertering for at sænke produktionsomkostninger"
      ]
    },
    "bg": {
      "title": "Управление на птици – Ma Petite Ferme",
      "description": "Следете партиди бройлери, патици, гъски и пуйки с Ma Petite Ferme. Контролирайте растежа, смъртността и фуражната ефективност за всеки производствен цикъл.",
      "h1": "Ефективно управление на птицевъдни групи",
      "intro": "Ma Petite Ferme събира данните за всички ваши птицевъдни партиди в една интуитивна платформа – от пилета до пуйки. Намалете загубите, следете теглото и оптимизирайте разхода на фураж с реални данни.",
      "bullets": [
        "Дневна регистрация на смъртност по партида и вид",
        "Криви на растеж спрямо породните стандарти",
        "Автоматични сигнали при отклонения в консумацията на фураж"
      ]
    },
    "el": {
      "title": "Διαχείριση πτηνοτροφίας – Ma Petite Ferme",
      "description": "Παρακολουθήστε παρτίδες κοτόπουλων, πάπιων, χηνών και γαλοπούλων με Ma Petite Ferme. Ελέγξτε ανάπτυξη, θνησιμότητα και αποδοτικότητα ζωοτροφών σε κάθε κύκλο.",
      "h1": "Έξυπνη διαχείριση κοπαδιών πτηνοτροφίας",
      "intro": "Η Ma Petite Ferme συγκεντρώνει όλα τα δεδομένα των παρτίδων πουλερικών σας σε ένα ενιαίο και εύχρηστο dashboard. Μειώστε τη θνησιμότητα, επιτύχετε στόχους βάρους και βελτιώστε το δείκτη μετατρεψιμότητας τροφής.",
      "bullets": [
        "Ημερήσια καταγραφή θνησιμότητας ανά παρτίδα και είδος",
        "Καμπύλες ανάπτυξης σε σύγκριση με πρότυπα φυλής",
        "Ειδοποιήσεις κατανάλωσης ζωοτροφών για μείωση κόστους"
      ]
    },
    "hr": {
      "title": "Upravljanje peradi i purama – Ma Petite Ferme",
      "description": "Pratite serije brojlera, pataka, gusaka i purana s Ma Petite Ferme. Kontrolirajte rast, smrtnost i konverziju hrane za svaki proizvodni ciklus peradi.",
      "h1": "Precizno praćenje peradarskih serija",
      "intro": "Ma Petite Ferme objedinjuje sve podatke vaših peradarskih serija – od pilića do purana – u jednoj preglednoj platformi. Smanjite gubitke, pratite prirast i optimizirajte potrošnju hrane uz pomoć stvarnih podataka.",
      "bullets": [
        "Dnevna evidencija smrtnosti po seriji i vrsti peradi",
        "Krivulje rasta uspoređene s rasnim standardima",
        "Automatska upozorenja pri odstupanjima u konzumaciji hrane"
      ]
    },
    "et": {
      "title": "Linnukasvatus – Ma Petite Ferme",
      "description": "Halda broilerite, partide, hanede ja kalkunite partiisid Ma Petite Ferme'iga. Jälgi kasvu, suremust ja söödaefektiivsust igas tootmistsüklis.",
      "h1": "Efektiivne linnukasvatus andmepõhiselt",
      "intro": "Ma Petite Ferme koondab kõikide teie linnukarjade andmed ühte selgesse juhtpaneeli, alates tibude esimesest päevast kuni tapakaaluni. Vähendage kaotusi, saavutage kaalueesmärgid ja optimeerige söödakulu reaalajas.",
      "bullets": [
        "Igapäevane suremuse registreerimine partii ja liigi kaupa",
        "Kasvukõverad võrrelduna tõustandarditega",
        "Automaatsed hoiatused söödakulu kõrvalekallete korral"
      ]
    },
    "fi": {
      "title": "Siipikarjan hallinta – Ma Petite Ferme",
      "description": "Seuraa broileri-, ankka-, hanhi- ja kalkkunaeriä Ma Petite Ferme -ohjelmistolla. Hallitse kasvua, kuolleisuutta ja rehutehokkuutta jokaisessa tuotantosyklissä.",
      "h1": "Hallitse siipikarjaerät tehokkaasti",
      "intro": "Ma Petite Ferme kokoaa kaikkien siipikarjaeriesi tiedot yhteen selkeään alustaan – broilereista kalkkunoihin. Vähennä tappioita, saavuta painotavoitteet ja optimoi rehunkäyttö ajantasaisen datan avulla.",
      "bullets": [
        "Päivittäinen kuolleisuuden kirjaus erä- ja lajikohtaisesti",
        "Kasvukäyrät verrattuna rotukohtaisiin viitearvoihin",
        "Automaattiset hälytykset poikkeavasta rehunkulutuksesta"
      ]
    },
    "hu": {
      "title": "Baromfi & pulyka kezelés – Ma Petite Ferme",
      "description": "Kövesse nyomon brojler-, kacsa-, lúd- és pulykacsapatait a Ma Petite Ferme segítségével. Ellenőrizze a növekedést, az elhullást és a takarmányhatékonyságot minden ciklusban.",
      "h1": "Hatékony baromfiállomány-kezelés adatok alapján",
      "intro": "A Ma Petite Ferme egyetlen átlátható felületen gyűjti össze az összes baromficsapatának adatait a naposcsibéktől a vágásra kész állatokig. Csökkentse az elhullást, tartsa be a súlycélokat és optimalizálja a takarmányköltségeket valós időben.",
      "bullets": [
        "Napi elhullás rögzítése csapatonként és fajta szerint",
        "Növekedési görbék összehasonlítása fajtaspecifikus normákkal",
        "Automatikus riasztások a takarmányfogyasztási eltérések esetén"
      ]
    },
    "lv": {
      "title": "Mājputnu audzēšana – Ma Petite Ferme",
      "description": "Pārvaldiet broileru, pīļu, zosu un tītaru partijas ar Ma Petite Ferme. Sekojiet augšanai, mirstībai un barības efektivitātei katrā ražošanas ciklā.",
      "h1": "Precīza mājputnu partiju pārvaldība",
      "intro": "Ma Petite Ferme apvieno visu jūsu mājputnu partiju datus vienā pārskatāmā platformā — no cāļiem līdz gataviem nokaušanai putniem. Samaziniet zudumus, sasniedziet svara mērķus un uzlabojiet barības konversiju ar reāla laika datiem.",
      "bullets": [
        "Ikdienas mirstības reģistrācija pa partijām un sugām",
        "Augšanas līknes salīdzinājumā ar šķirnes standartiem",
        "Automātiski brīdinājumi par barības patēriņa novirzēm"
      ]
    },
    "lt": {
      "title": "Paukštininkystė – Ma Petite Ferme",
      "description": "Valdykite broilerių, ančių, žąsų ir kalakutų partijas su Ma Petite Ferme. Stebėkite augimą, mirtingumą ir pašarų efektyvumą kiekviename gamybos cikle.",
      "h1": "Efektyvus naminių paukščių bandų valdymas",
      "intro": "Ma Petite Ferme sutelkia visų jūsų paukštininkystės partijų duomenis vienoje aiškioje platformoje – nuo vienos dienos viščiukų iki paruoštų skerdimui paukščių. Mažinkite nuostolius, siekite svorio tikslų ir optimizuokite pašarų sąnaudas realiuoju laiku.",
      "bullets": [
        "Kasdienė mirtingumo registracija pagal partiją ir rūšį",
        "Augimo kreivės, lyginamos su veislės standartais",
        "Automatiniai įspėjimai apie pašarų suvartojimo nukrypimus"
      ]
    },
    "pl": {
      "title": "Zarządzanie drobiem – Ma Petite Ferme",
      "description": "Zarządzaj partiami brojlerów, kaczek, gęsi i indyków z Ma Petite Ferme. Monitoruj wzrost, śmiertelność i efektywność pasz w każdym cyklu produkcyjnym.",
      "h1": "Skuteczne zarządzanie stadami drobiu",
      "intro": "Ma Petite Ferme gromadzi dane wszystkich partii drobiu w jednym przejrzystym panelu – od piskląt jednodniowych po ptaki gotowe do uboju. Ograniczaj padnięcia, realizuj cele wagowe i optymalizuj zużycie paszy na podstawie bieżących danych.",
      "bullets": [
        "Codzienna rejestracja padnięć według partii i gatunku",
        "Krzywe wzrostu porównane do norm rasowych",
        "Automatyczne alerty przy odchyleniach w zużyciu paszy"
      ]
    },
    "pt": {
      "title": "Gestão de aves de produção – Ma Petite Ferme",
      "description": "Gerencie lotes de frangos, patos, gansos e perus com Ma Petite Ferme. Acompanhe crescimento, mortalidade e eficiência alimentar em cada ciclo de produção avícola.",
      "h1": "Gerencie seus lotes avícolas com precisão",
      "intro": "A Ma Petite Ferme centraliza todos os dados dos seus lotes avícolas — de pintainhos a aves prontas para o abate — numa única plataforma intuitiva. Reduza perdas, atinja metas de peso e melhore a conversão alimentar com informações em tempo real.",
      "bullets": [
        "Registro diário de mortalidade por lote e espécie avícola",
        "Curvas de crescimento comparadas aos padrões da raça",
        "Alertas automáticos sobre desvios no consumo de ração"
      ]
    },
    "ro": {
      "title": "Creșterea păsărilor – Ma Petite Ferme",
      "description": "Gestionați loturi de broileri, rațe, gâște și curcani cu Ma Petite Ferme. Monitorizați creșterea, mortalitatea și eficiența furajelor în fiecare ciclu de producție.",
      "h1": "Gestionați eficient loturile de păsări de curte",
      "intro": "Ma Petite Ferme centralizează datele tuturor loturilor dvs. avicole într-un singur panou de control clar și ușor de folosit. Reduceți pierderile, atingeți obiectivele de greutate și optimizați consumul de furaje cu date în timp real.",
      "bullets": [
        "Înregistrarea zilnică a mortalității pe lot și specie",
        "Curbe de creștere comparate cu standardele rasei",
        "Alerte automate la abateri în consumul de furaje"
      ]
    },
    "sk": {
      "title": "Manažment hydiny – Ma Petite Ferme",
      "description": "Spravujte šarže brojlerov, kačíc, husí a moriek s Ma Petite Ferme. Sledujte rast, úhyny a efektívnosť krmiva v každom výrobnom cykle hydiny.",
      "h1": "Efektívna správa hydinových šarží",
      "intro": "Ma Petite Ferme zhromažďuje údaje všetkých vašich hydinových šarží v jednej prehľadnej platforme – od jednodňových kurčiat až po zvieratá pripravené na porážku. Znižujte úhyny, plňte hmotnostné ciele a optimalizujte spotrebu krmiva v reálnom čase.",
      "bullets": [
        "Denná evidencia úhynov podľa šarže a druhu hydiny",
        "Rastové krivky v porovnaní so štandardmi plemena",
        "Automatické upozornenia pri odchýlkach v spotrebe krmiva"
      ]
    },
    "sl": {
      "title": "Upravljanje perutnine – Ma Petite Ferme",
      "description": "Upravljajte serije brojlerjev, rac, gosi in puranov z Ma Petite Ferme. Sledite rasti, umrljivosti in učinkovitosti krme v vsakem proizvodnem ciklu.",
      "h1": "Učinkovito upravljanje jat perutnine",
      "intro": "Ma Petite Ferme združuje podatke vseh vaših serij perutnine v eni pregledni platformi – od enic do živali, pripravljenih za zakol. Zmanjšajte izgube, dosegajte težnostne cilje in optimizirajte porabo krme z realnimi podatki.",
      "bullets": [
        "Dnevno beleženje umrljivosti po seriji in vrsti perutnine",
        "Rastne krivulje v primerjavi s standardnimi vrednostmi pasme",
        "Samodejna opozorila pri odstopanjih v porabi krme"
      ]
    },
    "cs": {
      "title": "Správa hejn drůbeže – Ma Petite Ferme",
      "description": "Spravujte šarže brojlerů, kachen, hus a krůt s Ma Petite Ferme. Sledujte růst, úhyny a efektivitu krmiva v každém výrobním cyklu drůbežárny.",
      "h1": "Efektivní správa drůbežích hejn",
      "intro": "Ma Petite Ferme shromažďuje data všech vašich drůbežích šarží v jedné přehledné platformě – od jednodenních kuřat až po zvířata připravená k porážce. Snižujte úhyny, plňte hmotnostní cíle a optimalizujte spotřebu krmiva v reálném čase.",
      "bullets": [
        "Denní evidence úhynů podle šarže a druhu drůbeže",
        "Růstové křivky srovnané se standardy plemene",
        "Automatická upozornění při odchylkách ve spotřebě krmiva"
      ]
    }
  },
  "chevres": {
    "fr": {
      "title": "Élevage de chèvres – Ma Petite Ferme",
      "description": "Gérez votre troupeau caprin avec précision : suivi des lactations, des mises bas et de la reproduction. Ma Petite Ferme simplifie votre élevage au quotidien.",
      "h1": "Logiciel de gestion pour éleveurs caprins",
      "intro": "Ma Petite Ferme centralise toutes les données de votre cheptel caprin en un seul outil intuitif. Optimisez vos rendements laitiers et planifiez chaque mise bas sans effort.",
      "bullets": [
        "Suivez la production laitière de chaque chèvre individuellement",
        "Planifiez les saillies et détectez les chaleurs facilement",
        "Enregistrez chaque chevreau à la naissance avec traçabilité complète"
      ]
    },
    "en": {
      "title": "Goat Herd Management – Ma Petite Ferme",
      "description": "Track milk yield, kidding records and breeding cycles for your entire goat herd. Ma Petite Ferme gives dairy and meat goat farmers the tools they need to thrive.",
      "h1": "Smart goat farm management software",
      "intro": "Ma Petite Ferme helps goat breeders stay on top of every doe's production, health, and reproductive cycle. Whether you raise dairy or meat goats, every record is one tap away.",
      "bullets": [
        "Monitor individual doe milk yield and lactation curves",
        "Schedule kidding dates and track kid births effortlessly",
        "Manage buck breeding records and detect heat cycles"
      ]
    },
    "es": {
      "title": "Gestión de cabras – Ma Petite Ferme",
      "description": "Controla la producción láctea, los partos y la reproducción de tu rebaño caprino. Ma Petite Ferme es el aliado digital de todo ganadero de cabras.",
      "h1": "Software caprino para ganaderos profesionales",
      "intro": "Ma Petite Ferme te permite llevar un registro preciso de cada cabra, desde su producción de leche hasta sus ciclos reproductivos. Mejora la rentabilidad de tu explotación caprina con datos claros y accesibles.",
      "bullets": [
        "Registra la producción de leche por cabra y campaña",
        "Planifica los partos y gestiona los cabritos recién nacidos",
        "Controla ciclos reproductivos y temporadas de cubrición"
      ]
    },
    "it": {
      "title": "Allevamento capre – Ma Petite Ferme",
      "description": "Monitora la produzione di latte, i parti e la riproduzione del tuo gregge caprino. Ma Petite Ferme è il gestionale pensato per gli allevatori di capre da latte e da carne.",
      "h1": "Gestionale capre per allevatori moderni",
      "intro": "Ma Petite Ferme ti offre uno strumento completo per seguire ogni capra del gregge, dalla lattazione ai cicli riproduttivi. Risparmia tempo e aumenta la redditività del tuo allevamento caprino.",
      "bullets": [
        "Traccia la curva di lattazione di ogni singola capra",
        "Programma parti e registra i capretti alla nascita",
        "Gestisci le monte e monitora i calori con precisione"
      ]
    },
    "de": {
      "title": "Ziegenhaltung verwalten – Ma Petite Ferme",
      "description": "Milchleistung, Ablammungen und Reproduktion Ihrer Ziegenherde effizient im Blick. Ma Petite Ferme ist die Softwarelösung für Milch- und Fleischziegenhalter.",
      "h1": "Ziegenherde digital und effizient verwalten",
      "intro": "Mit Ma Petite Ferme behalten Sie jederzeit den Überblick über Milchleistung, Gesundheit und Brunstzyklen Ihrer Ziegen. Planen Sie Ablammungen voraus und dokumentieren Sie jeden Ziegenbock-Einsatz lückenlos.",
      "bullets": [
        "Individuelle Milchleistung jeder Ziege erfassen und auswerten",
        "Ablammtermine planen und Zicklein lückenlos registrieren",
        "Brunstzyklen überwachen und Belegungen termingerecht steuern"
      ]
    },
    "nl": {
      "title": "Geitenbedrijf beheren – Ma Petite Ferme",
      "description": "Houd melkproductie, lammeren en voortplanting van uw geitenkudde bij. Ma Petite Ferme biedt melk- en vleesgeiten­houders een compleet digitaal beheerplatform.",
      "h1": "Digitaal beheer voor geitenhouders",
      "intro": "Ma Petite Ferme geeft geitenhouders één overzichtelijk platform voor melkregistratie, fokkerij en gezondheidsbeheer. Plan lammertijden vooruit en volg elke geit van geboorte tot productie.",
      "bullets": [
        "Registreer melkproductie per geit en lactatieronde",
        "Plan lammertijden en leg geboorten direct vast",
        "Bewaak loops­cyclussen en plan dekkingen nauwkeurig"
      ]
    },
    "sv": {
      "title": "Getskötsel – Ma Petite Ferme",
      "description": "Följ mjölkproduktion, killningar och reproduktion i din getbesättning. Ma Petite Ferme ger dig full kontroll över din mjölk- eller köttgetsgård med smart digital teknik.",
      "h1": "Smart mjukvara för getuppfödare",
      "intro": "Ma Petite Ferme samlar alla uppgifter om din getbesättning på ett ställe – från mjölkregistrering till brunstcykler. Planera killningar i förväg och optimera produktiviteten på din getgård.",
      "bullets": [
        "Registrera varje gets mjölkavkastning och laktationskurva",
        "Planera killningar och registrera killingar vid födseln",
        "Övervaka brunstcykler och schemalägg betäckningar enkelt"
      ]
    },
    "da": {
      "title": "Gedehold – Ma Petite Ferme",
      "description": "Styr mælkeydelse, kælvninger og reproduktion i din gedebesætning. Ma Petite Ferme er det digitale værktøj, der hjælper mælke- og kødgedeavlere med at arbejde smartere.",
      "h1": "Digital styring af din gedebesætning",
      "intro": "Med Ma Petite Ferme får du fuld overblik over hver geds mælkeproduktion, sundhed og brunstcyklus. Planlæg kælvninger i god tid og registrer kidene straks ved fødslen.",
      "bullets": [
        "Registrer mælkeydelse pr. ged og laktationsperiode",
        "Planlæg kælvningsdatoer og følg kidenes udvikling",
        "Overvåg brunstcyklusser og styr bedækning præcist"
      ]
    },
    "bg": {
      "title": "Управление на кози – Ma Petite Ferme",
      "description": "Проследявайте млеконадоя, козленето и размножаването на вашето стадо. Ma Petite Ferme е дигиталното решение за всеки развъдник на млечни и месни кози.",
      "h1": "Дигитално управление на козевъдна ферма",
      "intro": "Ma Petite Ferme ви дава пълен контрол върху всяка коза – от млечната продуктивност до репродуктивните цикли. Планирайте козленето и оптимизирайте приходите на вашата ферма.",
      "bullets": [
        "Следете млечния надой на всяка коза поотделно",
        "Планирайте козленето и регистрирайте малките при раждане",
        "Контролирайте еструса и управлявайте разплода ефективно"
      ]
    },
    "el": {
      "title": "Εκτροφή κατσικών – Ma Petite Ferme",
      "description": "Παρακολουθήστε γαλακτοπαραγωγή, γεννήσεις και αναπαραγωγή της αιγοτροφικής σας μονάδας. Το Ma Petite Ferme είναι το ψηφιακό εργαλείο για κάθε αιγοτρόφο.",
      "h1": "Ψηφιακή διαχείριση αιγοτροφικής εκτροφής",
      "intro": "Το Ma Petite Ferme συγκεντρώνει όλα τα δεδομένα της αγέλης σας σε μια πλατφόρμα – από την παραγωγή γάλακτος έως τους αναπαραγωγικούς κύκλους. Σχεδιάστε τοκετούς και βελτιστοποιήστε την απόδοση της εκτροφής σας.",
      "bullets": [
        "Καταγράψτε γαλακτοπαραγωγή κάθε κατσίκας ξεχωριστά",
        "Προγραμματίστε τοκετούς και καταχωρήστε τα ερίφια αμέσως",
        "Παρακολουθήστε οίστρους και διαχειριστείτε αναπαραγωγή αποτελεσματικά"
      ]
    },
    "hr": {
      "title": "Uzgoj koza – Ma Petite Ferme",
      "description": "Pratite mliječnost, jarenje i reprodukciju vašeg kozjeg stada. Ma Petite Ferme digitalno rješenje za uzgajivače mliječnih i mesnih koza u Hrvatskoj i regiji.",
      "h1": "Digitalno upravljanje kozjim stadom",
      "intro": "Ma Petite Ferme omogućuje vam potpun uvid u proizvodnju mlijeka, zdravlje i reproduktivne cikluse svake koze. Planirajte jarenje unaprijed i pratite razvoj jaradi od rođenja.",
      "bullets": [
        "Bilježite mliječnost svake koze i laktacijsku krivulju",
        "Planirajte jarenja i registrirajte jarad odmah po porodu",
        "Pratite tjeranje i upravljajte rasplodnim ciklusima precizno"
      ]
    },
    "et": {
      "title": "Kitsede haldamine – Ma Petite Ferme",
      "description": "Jälgige oma kitsekarja piimajõudlust, poegimisi ja paaritumistsükleid. Ma Petite Ferme on digitaalne tööriist piima- ja lihakitsekasvatajatele.",
      "h1": "Nutikas tarkvara kitsekasvatajatele",
      "intro": "Ma Petite Ferme koondab kõik teie kitsekarja andmed – piimajõudlusest kuni tiinustsükliteni – ühte lihtsasse keskkonda. Planeerige poegimisi ette ja optimeerige oma farmi tootlikkust.",
      "bullets": [
        "Registreerige iga kitse piimatoodang ja laktatsioonikõver",
        "Planeerige poegimisi ja salvestage talled kohe sünni järel",
        "Jälgige innatsükleid ja hallake paaritumist tõhusalt"
      ]
    },
    "fi": {
      "title": "Vuohikasvatus – Ma Petite Ferme",
      "description": "Seuraa maitomäärää, poikimisia ja lisääntymistä vuohilaumassasi. Ma Petite Ferme on digitaalinen työkalu maito- ja lihavuohitiloille tehokkaan hallinnan tueksi.",
      "h1": "Älykäs ohjelmisto vuohikasvattajille",
      "intro": "Ma Petite Ferme kokoaa kaikki vuohilaumasi tiedot yhteen helposti käytettävään palveluun maidontuotannosta kiimakiertoihin. Suunnittele poikimiset etukäteen ja paranna tilasi kannattavuutta.",
      "bullets": [
        "Kirjaa jokaisen vuohen maitotuotos ja laktaatiokäyrä",
        "Suunnittele poikimiset ja rekisteröi kilit heti syntymän jälkeen",
        "Seuraa kiimakiertoja ja hallinnoi astutuksia tarkasti"
      ]
    },
    "hu": {
      "title": "Kecsketenyésztés – Ma Petite Ferme",
      "description": "Kövesse nyomon kecskéi tejhozamát, elléseit és szaporodási ciklusait. A Ma Petite Ferme a tej- és húskecske-tenyésztők digitális gazdaságirányítási megoldása.",
      "h1": "Okos szoftver kecsketenyésztőknek",
      "intro": "A Ma Petite Ferme egyetlen felületen kezeli a teljes kecskéállomány tejhozam-adatait, egészségi állapotát és szaporodási ciklusait. Tervezze meg az elléseket előre, és maximalizálja farmja hatékonyságát.",
      "bullets": [
        "Egyenként rögzítse minden kecske tejhozamát és laktációs görbéjét",
        "Tervezze az elléseket és regisztrálja a gidákat azonnal születésükkor",
        "Figyelje az ivarzási ciklusokat és irányítsa a fedeztetéseket pontosan"
      ]
    },
    "lv": {
      "title": "Kazu audzēšana – Ma Petite Ferme",
      "description": "Sekojiet kazu ganāmpulka piena ražībai, atnešanās datumiem un vaislas cikliem. Ma Petite Ferme ir digitāls rīks piena un gaļas kazu audzētājiem.",
      "h1": "Digitāla kazu saimniecības pārvaldība",
      "intro": "Ma Petite Ferme apkopo visus jūsu kazu ganāmpulka datus – no piena ražības līdz reproduktīvajiem cikliem – vienā ērtā platformā. Plānojiet atnešanos laikus un uzlabojiet savas fermas rentabilitāti.",
      "bullets": [
        "Reģistrējiet katras kazas piena ražību un laktācijas līkni",
        "Plānojiet atnešanās datumus un reģistrējiet kazlēnus dzimšanas brīdī",
        "Uzraugiet estrus ciklus un pārvaldiet pārošanu efektīvi"
      ]
    },
    "lt": {
      "title": "Ožių auginimas – Ma Petite Ferme",
      "description": "Stebėkite ožių bandos pieningumą, ėriavimąsi ir reprodukcinius ciklus. Ma Petite Ferme – skaitmeninis įrankis pieno ir mėsos ožių augintojams.",
      "h1": "Išmanus programinės įrangos sprendimas ožiaugintojams",
      "intro": "Ma Petite Ferme surenka visus jūsų ožių bandos duomenis – nuo pieno primilžio iki veisimo ciklų – į vieną patogią platformą. Planuokite ėriavimąsi iš anksto ir didinkite ūkio pelningumą.",
      "bullets": [
        "Registruokite kiekvienos ožkos primilžį ir laktacijos kreivę",
        "Planuokite ėriavimosi datas ir iš karto registruokite ožiukus",
        "Stebėkite rujos ciklus ir valdykite veisimą tiksliai"
      ]
    },
    "pl": {
      "title": "Hodowla kóz – Ma Petite Ferme",
      "description": "Śledź wydajność mleczną, wykozy i cykle rozrodcze swojego stada kóz. Ma Petite Ferme to cyfrowe narzędzie dla hodowców kóz mlecznych i mięsnych.",
      "h1": "Oprogramowanie dla hodowców kóz",
      "intro": "Ma Petite Ferme gromadzi wszystkie dane Twojego stada kóz w jednym miejscu – od wydajności mlecznej po cykle rozrodcze. Planuj wykoty z wyprzedzeniem i zwiększaj rentowność swojego gospodarstwa.",
      "bullets": [
        "Rejestruj wydajność mleczną każdej kozy i krzywą laktacji",
        "Planuj wykoty i rejestruj koźlęta bezpośrednio po urodzeniu",
        "Monitoruj cykle rujowe i zarządzaj kryciem precyzyjnie"
      ]
    },
    "pt": {
      "title": "Criação de cabras – Ma Petite Ferme",
      "description": "Controle a produção de leite, as parições e a reprodução do seu rebanho caprino. Ma Petite Ferme é a solução digital para criadores de cabras leiteiras e de corte.",
      "h1": "Software caprino para criadores modernos",
      "intro": "Ma Petite Ferme reúne todos os dados do seu rebanho caprino numa única plataforma intuitiva, da produção leiteira aos ciclos reprodutivos. Planeie as parições com antecedência e maximize a rentabilidade da sua exploração.",
      "bullets": [
        "Registe a produção de leite de cada cabra e a curva de lactação",
        "Planeie parições e registe cabritos imediatamente após o nascimento",
        "Monitorize ciclos de cio e gira a cobrição com precisão"
      ]
    },
    "ro": {
      "title": "Creșterea caprelor – Ma Petite Ferme",
      "description": "Urmăriți producția de lapte, fătările și reproducția turmei de capre. Ma Petite Ferme este soluția digitală pentru crescătorii de capre de lapte și de carne.",
      "h1": "Software pentru crescători de capre",
      "intro": "Ma Petite Ferme centralizează toate datele turmei dvs. caprine – de la producția de lapte până la ciclurile reproductive – într-o singură platformă ușor de utilizat. Planificați fătările din timp și optimizați rentabilitatea fermei.",
      "bullets": [
        "Înregistrați producția de lapte a fiecărei capre individual",
        "Planificați fătările și înregistrați iezii imediat la naștere",
        "Monitorizați ciclurile de călduri și gestionați monta eficient"
      ]
    },
    "sk": {
      "title": "Chov kôz – Ma Petite Ferme",
      "description": "Sledujte dojivosť, kozenie a reprodukciu vášho stáda kôz. Ma Petite Ferme je digitálny nástroj pre chovateľov mliečnych a mäsových kôz na efektívne riadenie farmy.",
      "h1": "Softvér pre chovateľov kôz",
      "intro": "Ma Petite Ferme zhromažďuje všetky údaje vášho kozieho stáda – od dojivosti až po reprodukčné cykly – na jednej prehľadnej platforme. Plánujte kozenie vopred a zvyšujte výnosnosť svojho hospodárstva.",
      "bullets": [
        "Zaznamenávajte dojivosť každej kozy a laktačnú krivku",
        "Plánujte termíny kozenia a registrujte kozľatá pri narodení",
        "Sledujte ruje a riaďte pripúšťanie s presnosťou"
      ]
    },
    "sl": {
      "title": "Reja koz – Ma Petite Ferme",
      "description": "Spremljajte mlečnost, kozitve in razmnoževanje vaše črede koz. Ma Petite Ferme je digitalno orodje za rejce mlečnih in mesnih koz za učinkovito upravljanje kmetije.",
      "h1": "Digitalno upravljanje reje koz",
      "intro": "Ma Petite Ferme zbira vse podatke vaše črede koz – od mlečne proizvodnje do reproduktivnih ciklov – na enem preglednem mestu. Načrtujte kozitve vnaprej in povečajte donosnost vaše kmetije.",
      "bullets": [
        "Beležite mlečnost vsake koze in njeno laktacijsko krivuljo",
        "Načrtujte kozitve in registrirajte kozličke takoj ob rojstvu",
        "Spremljajte gonitev in upravljajte pripust natančno"
      ]
    },
    "cs": {
      "title": "Chov koz – Ma Petite Ferme",
      "description": "Sledujte dojivost, kození a reprodukci vašeho stáda koz. Ma Petite Ferme je digitální nástroj pro chovatele mléčných a masných koz k efektivnímu řízení farmy.",
      "h1": "Software pro chovatele koz",
      "intro": "Ma Petite Ferme shromažďuje veškerá data vašeho kozího stáda – od dojivosti až po reprodukční cykly – na jedné přehledné platformě. Plánujte kození dopředu a zvyšujte výnosnost svého hospodářství.",
      "bullets": [
        "Zaznamenávejte dojivost každé kozy a její laktační křivku",
        "Plánujte termíny kození a registrujte kůzlata při narození",
        "Sledujte říje a řiďte připouštění s maximální přesností"
      ]
    }
  },
  "moutons": {
    "fr": {
      "title": "Élevage ovin simplifié | Ma Petite Ferme",
      "description": "Gérez vos agneaux, agnelages et la santé de votre troupeau ovin avec Ma Petite Ferme. Suivi laitier, lainier et viande en un seul outil intuitif.",
      "h1": "Gérez votre troupeau ovin facilement",
      "intro": "Ma Petite Ferme centralise le suivi de chaque brebis, de l'agnelage à la tonte. Gagnez du temps et améliorez la rentabilité de votre élevage ovin.",
      "bullets": [
        "Planifiez les agnelages et suivez chaque naissance facilement",
        "Gérez la santé et les vaccinations de tout le troupeau",
        "Optimisez vos rendements laine et viande par animal"
      ]
    },
    "en": {
      "title": "Sheep Flock Management | Ma Petite Ferme",
      "description": "Track lambing, wool production, health records and flock performance with Ma Petite Ferme. The smart solution built for sheep and lamb breeders.",
      "h1": "Smart software for sheep breeders",
      "intro": "Ma Petite Ferme gives you complete visibility over every ewe, lamb and fleece in your flock. Reduce losses, plan lambing seasons and grow your operation with confidence.",
      "bullets": [
        "Track every lambing event and newborn lamb instantly",
        "Schedule vaccinations and treatments across the whole flock",
        "Monitor wool yield and meat performance per individual animal"
      ]
    },
    "es": {
      "title": "Gestión de ovejas y corderos | Ma Petite Ferme",
      "description": "Controla partos, sanidad, producción de lana y carne de tu rebaño ovino con Ma Petite Ferme. La herramienta que todo ganadero ovino necesita.",
      "h1": "Gestiona tu rebaño ovino con precisión",
      "intro": "Ma Petite Ferme te permite registrar cada oveja, cada parto y cada tratamiento veterinario en un solo lugar. Mejora la productividad de tu explotación ovina sin complicaciones.",
      "bullets": [
        "Registra partos y supervisa corderos recién nacidos fácilmente",
        "Planifica desparasitaciones y vacunas para todo el rebaño",
        "Analiza rendimiento de lana y carne por animal individualmente"
      ]
    },
    "it": {
      "title": "Allevamento ovini digitale | Ma Petite Ferme",
      "description": "Monitora agnellamenti, salute del gregge, lana e carne con Ma Petite Ferme. Il gestionale pensato per gli allevatori ovini italiani, semplice ed efficace.",
      "h1": "Il tuo gregge sotto controllo sempre",
      "intro": "Ma Petite Ferme ti aiuta a seguire ogni pecora, ogni agnello e ogni trattamento sanitario in modo semplice e veloce. Aumenta la produttività del tuo allevamento ovino con dati sempre aggiornati.",
      "bullets": [
        "Registra ogni agnellamento e monitora i neonati in tempo reale",
        "Pianifica vaccinazioni e profilassi per l'intero gregge",
        "Tieni traccia della resa in lana e carne per ogni animale"
      ]
    },
    "de": {
      "title": "Schafhaltung digital verwalten | Ma Petite Ferme",
      "description": "Lammungen, Herdengesundheit, Wolle- und Fleischleistung im Blick – mit Ma Petite Ferme. Die Softwarelösung für professionelle Schafhalter und Züchter.",
      "h1": "Schafherde effizient und digital managen",
      "intro": "Ma Petite Ferme bündelt alle Daten Ihrer Herde – von der Lammung bis zur Schur – in einer übersichtlichen Plattform. Sparen Sie Zeit, senken Sie Verluste und steigern Sie die Wirtschaftlichkeit Ihres Schafbetriebs.",
      "bullets": [
        "Lammungen dokumentieren und Neugeborene lückenlos erfassen",
        "Impfpläne und Behandlungen für die gesamte Herde verwalten",
        "Woll- und Fleischleistung je Tier auswerten und optimieren"
      ]
    },
    "nl": {
      "title": "Schapenhouderij beheren | Ma Petite Ferme",
      "description": "Beheer lammeren, aflammen, gezondheid en wol- of vleesproductie van uw kudde met Ma Petite Ferme. Eén overzichtelijke tool voor schapenhouders.",
      "h1": "Uw schaapskudde slim beheren",
      "intro": "Ma Petite Ferme brengt alle gegevens van uw schapen samen op één plek, van aflammeren tot scheren. Bespaar tijd, verbeter de diergezondheid en verhoog de opbrengst van uw schapenhouderij.",
      "bullets": [
        "Registreer elk aflam-moment en volg lammeren nauwkeurig op",
        "Plan vaccinaties en behandelingen voor de gehele kudde",
        "Analyseer wol- en vleesopbrengst per individueel dier"
      ]
    },
    "sv": {
      "title": "Hantera din fårbesättning | Ma Petite Ferme",
      "description": "Följ lammningar, hälsa, ull och köttproduktion i hela besättningen med Ma Petite Ferme. Smarta verktyg för svenska fåruppfödare och lantbrukare.",
      "h1": "Effektiv skötsel av din fårbesättning",
      "intro": "Ma Petite Ferme samlar all information om dina får – från lammning till klippning – på ett och samma ställe. Minska förlusterna, planera bättre och öka lönsamheten i din fårproduktion.",
      "bullets": [
        "Registrera lammningar och följ upp nyfödda lamm direkt",
        "Planera vaccinationer och behandlingar för hela besättningen",
        "Analysera ull- och köttavkastning per enskilt djur enkelt"
      ]
    },
    "da": {
      "title": "Styring af fårehold | Ma Petite Ferme",
      "description": "Administrer lamninger, sundhed, uld og kødproduktion i din fåreflok med Ma Petite Ferme. Det intuitive redskab til danske fåreavlere og landmænd.",
      "h1": "Hold styr på din fåreflok nemt",
      "intro": "Ma Petite Ferme samler alle oplysninger om dine får – fra lamning til klipning – ét centralt sted. Spar tid, forebyg tab og forbedre rentabiliteten i dit fårebrug med præcise data.",
      "bullets": [
        "Registrer lamninger og følg nyfødte lam i realtid",
        "Planlæg vaccinationer og behandlinger for hele flokken",
        "Analyser uld- og kødydelse pr. dyr for bedre beslutninger"
      ]
    },
    "bg": {
      "title": "Управление на овце | Ma Petite Ferme",
      "description": "Следете агнения, здравето на стадото, вълната и месото с Ma Petite Ferme. Дигитален инструмент, създаден специално за овцевъди и животновъди.",
      "h1": "Управлявайте стадото си с лекота",
      "intro": "Ma Petite Ferme обединява всички данни за вашите овце – от агненето до стрижбата – на едно място. Намалете загубите, подобрете здравето на животните и увеличете рентабилността на фермата си.",
      "bullets": [
        "Записвайте всяко агнене и проследявайте новородените агнета",
        "Планирайте ваксинации и лечения за цялото стадо лесно",
        "Анализирайте добива на вълна и месо на животно поотделно"
      ]
    },
    "el": {
      "title": "Διαχείριση κοπαδιού προβάτων | Ma Petite Ferme",
      "description": "Παρακολουθήστε αρνοτοκίες, υγεία κοπαδιού, μαλλί και κρέας με το Ma Petite Ferme. Το ψηφιακό εργαλείο που χρειάζεται κάθε κτηνοτρόφος προβάτων.",
      "h1": "Διαχειριστείτε το κοπάδι σας έξυπνα",
      "intro": "Το Ma Petite Ferme συγκεντρώνει όλα τα δεδομένα των προβάτων σας σε ένα μέρος, από την αρνοτοκία έως το κούρεμα. Μειώστε τις απώλειες και αυξήστε την παραγωγικότητα της κτηνοτροφικής σας μονάδας.",
      "bullets": [
        "Καταγράφετε κάθε αρνοτοκία και παρακολουθείτε τα νεογέννητα",
        "Προγραμματίζετε εμβολιασμούς και θεραπείες σε όλο το κοπάδι",
        "Αναλύετε απόδοση μαλλιού και κρέατος ανά ζώο εύκολα"
      ]
    },
    "hr": {
      "title": "Upravljanje stadom ovaca | Ma Petite Ferme",
      "description": "Pratite janjenja, zdravlje stada, vunu i meso s Ma Petite Ferme. Digitalni alat koji svakom uzgajivaču ovaca olakšava svakodnevno upravljanje farmom.",
      "h1": "Vaše stado ovaca pod kontrolom",
      "intro": "Ma Petite Ferme objedinjuje sve podatke o vašim ovcama – od janjenja do šišanja – na jednom preglednom mjestu. Smanjite gubitke, poboljšajte zdravlje životinja i povećajte prihode farme.",
      "bullets": [
        "Bilježite svako janjenje i pratite novorođenu janjad odmah",
        "Planirajte cijepljenja i tretmane za cijelo stado jednostavno",
        "Analizirajte prinos vune i mesa po svakoj životinji posebno"
      ]
    },
    "et": {
      "title": "Lammaste karja haldamine | Ma Petite Ferme",
      "description": "Jälgige tallesid, tervist, villa ja lihatoodangut kogu karjas Ma Petite Ferme'iga. Nutikas tööriist lambakasvatajaile ja väikefarmeritele igal pool.",
      "h1": "Halda oma lambakarja nutikalt",
      "intro": "Ma Petite Ferme koondab kõik teie lammaste andmed – tallede sünnist kuni pügamiseni – ühte mugavasse kohta. Vähendage kaotusi, planeerige paremini ja suurendage oma lambafarm kasumit.",
      "bullets": [
        "Registreerige iga tallesünd ja jälgige vastsündinuid reaalajas",
        "Planeerige vaktsineerimised ja ravid kogu karjale hõlpsalt",
        "Analüüsige villa ja lihatoodangut iga looma kohta eraldi"
      ]
    },
    "fi": {
      "title": "Lammaslauman hallinta | Ma Petite Ferme",
      "description": "Seuraa karitsoinnit, terveys, villa ja lihantuotanto koko laumassa Ma Petite Ferme -sovelluksella. Helppo työkalu suomalaisille lammaskasvattajille.",
      "h1": "Hallitse lammastasi älykkäästi",
      "intro": "Ma Petite Ferme kokoaa kaiken lammastietosi – karitsoinnista kerintään – yhteen selkeään paikkaan. Vähennä tappioita, paranna eläinten terveyttä ja kasvata lammasfarmisi kannattavuutta.",
      "bullets": [
        "Kirjaa jokainen karitsointi ja seuraa vastasyntyneitä reaaliajassa",
        "Suunnittele rokotukset ja hoidot koko laumalle vaivattomasti",
        "Analysoi villa- ja lihatuotto eläinkohtaisesti tarkasti"
      ]
    },
    "hu": {
      "title": "Juhnyáj kezelése egyszerűen | Ma Petite Ferme",
      "description": "Kövesse nyomon a bárányozást, az állomány egészségét, a gyapjú- és hústermelést a Ma Petite Ferme-mel. Az okos megoldás minden juhász és tenyésztő számára.",
      "h1": "Kezelje juhnyáját hatékonyan",
      "intro": "A Ma Petite Ferme egyetlen helyen gyűjti össze az összes adatot juhairól – a bárányozástól a nyírásig. Csökkentse a veszteségeket, javítsa az állatok egészségét és növelje farmja jövedelmezőségét.",
      "bullets": [
        "Rögzítsen minden bárányozást és kövesse az újszülötteket azonnal",
        "Tervezze meg az oltásokat és kezeléseket az egész nyájra",
        "Elemezze a gyapjú- és húshozamot állatonként külön-külön"
      ]
    },
    "lv": {
      "title": "Aitu bara pārvaldība | Ma Petite Ferme",
      "description": "Sekojiet jēru dzimšanai, bara veselībai, vilnai un gaļas ražošanai ar Ma Petite Ferme. Digitālais rīks ikviena aitu audzētāja ikdienas darbam.",
      "h1": "Pārvaldiet aitu baru gudri",
      "intro": "Ma Petite Ferme apkopo visus datus par jūsu aitām – no atnešanās līdz cirpšanai – vienā ērtā vietā. Maziniet zudumus, uzlabojiet dzīvnieku veselību un palieliniet savas fermas rentabilitāti.",
      "bullets": [
        "Reģistrējiet katru jēra piedzimšanu un sekojiet jaundzimušajiem",
        "Plānojiet vakcinācijas un ārstēšanu visam baram ērti",
        "Analizējiet vilnas un gaļas ražu katram dzīvniekam atsevišķi"
      ]
    },
    "lt": {
      "title": "Avių bandos valdymas | Ma Petite Ferme",
      "description": "Stebėkite ėriavimąsi, bandos sveikatą, vilną ir mėsos produkciją su Ma Petite Ferme. Išmanus įrankis avių augintojams ir ūkininkams kasdieniam darbui.",
      "h1": "Valdykite avių bandą išmaniai",
      "intro": "Ma Petite Ferme surenka visus duomenis apie jūsų avis – nuo ėriavimosi iki kirpimo – vienoje patogioje vietoje. Sumažinkite nuostolius, gerinkite gyvūnų sveikatą ir didinkite ūkio pelningumą.",
      "bullets": [
        "Fiksuokite kiekvieną ėriavimąsi ir stebėkite naujagimius avinėlius",
        "Planuokite skiepijimus ir gydymus visai bandai paprastai",
        "Analizuokite vilnos ir mėsos derlių kiekvienam gyvūnui atskirai"
      ]
    },
    "pl": {
      "title": "Zarządzanie stadem owiec | Ma Petite Ferme",
      "description": "Śledź wykoty, zdrowie stada, wełnę i produkcję mięsa z Ma Petite Ferme. Cyfrowe narzędzie stworzone dla hodowców owiec i małych gospodarstw rolnych.",
      "h1": "Zarządzaj stadem owiec efektywnie",
      "intro": "Ma Petite Ferme gromadzi wszystkie dane o Twoich owcach – od wykotu do strzyżenia – w jednym przejrzystym miejscu. Zmniejsz straty, popraw zdrowie zwierząt i zwiększ rentowność swojej owczarni.",
      "bullets": [
        "Rejestruj każdy wykot i monitoruj nowonarodzone jagnięta na bieżąco",
        "Planuj szczepienia i leczenia dla całego stada z łatwością",
        "Analizuj wydajność wełny i mięsa dla każdego zwierzęcia osobno"
      ]
    },
    "pt": {
      "title": "Gestão de rebanho ovino | Ma Petite Ferme",
      "description": "Controle parições, saúde do rebanho, lã e carne com Ma Petite Ferme. A solução digital que todo criador de ovelhas precisa para gerir melhor a sua exploração.",
      "h1": "Gira o seu rebanho ovino com precisão",
      "intro": "Ma Petite Ferme centraliza todos os dados das suas ovelhas – desde a parição até à tosquia – numa só plataforma intuitiva. Reduza perdas, melhore a saúde animal e aumente a rentabilidade da sua exploração ovina.",
      "bullets": [
        "Registe cada parição e acompanhe os borregos recém-nascidos facilmente",
        "Planeie vacinações e tratamentos para todo o rebanho de forma simples",
        "Analise o rendimento de lã e carne por animal individualmente"
      ]
    },
    "ro": {
      "title": "Gestionare turmă ovine | Ma Petite Ferme",
      "description": "Monitorizați fătările, sănătatea turmei, lâna și carnea cu Ma Petite Ferme. Instrumentul digital pentru crescătorii de oi care vor să-și eficientizeze ferma.",
      "h1": "Gestionați turma de oi eficient",
      "intro": "Ma Petite Ferme centralizează toate datele oilor dvs. – de la fătare până la tuns – într-o singură platformă ușor de folosit. Reduceți pierderile, îmbunătățiți sănătatea animalelor și creșteți profitabilitatea fermei.",
      "bullets": [
        "Înregistrați fiecare fătare și monitorizați mieii nou-născuți imediat",
        "Planificați vaccinările și tratamentele pentru întreaga turmă ușor",
        "Analizați producția de lână și carne pe fiecare animal în parte"
      ]
    },
    "sk": {
      "title": "Správa stáda oviec | Ma Petite Ferme",
      "description": "Sledujte jahňatá, zdravie stáda, vlnu a produkciu mäsa s Ma Petite Ferme. Digitálny nástroj pre chovateľov oviec, ktorý uľahčuje každodenné riadenie farmy.",
      "h1": "Spravujte stádo oviec inteligentne",
      "intro": "Ma Petite Ferme zhromažďuje všetky údaje o vašich ovciach – od obahnenia po strihanie – na jednom prehľadnom mieste. Znížte straty, zlepšite zdravie zvierat a zvýšte rentabilitu vašej farmy.",
      "bullets": [
        "Zaznamenajte každé obahnenie a sledujte novonarodeného jahňaťa hneď",
        "Plánujte očkovania a liečby pre celé stádo jednoduchým spôsobom",
        "Analyzujte úžitkovosť vlny a mäsa pre každé zviera zvlášť"
      ]
    },
    "sl": {
      "title": "Upravljanje tropa ovac | Ma Petite Ferme",
      "description": "Sledite jagnitvam, zdravju tropa, volni in mesu z Ma Petite Ferme. Digitalno orodje za rejce ovac, ki želi boljši pregled nad svojo kmetijo vsak dan.",
      "h1": "Upravljajte trop ovac pregledno",
      "intro": "Ma Petite Ferme zbira vse podatke o vaših ovcah – od jagnjitve do striženja – na enem preglednem mestu. Zmanjšajte izgube, izboljšajte zdravje živali in povečajte donosnost vaše ovčje farme.",
      "bullets": [
        "Beležite vsako jagnjitev in sproti spremljajte novorojene jagnce",
        "Načrtujte cepljenja in zdravljenja za celoten trop preprosto",
        "Analizirajte pridelek volne in mesa za vsako žival posebej"
      ]
    },
    "cs": {
      "title": "Správa stáda ovcí | Ma Petite Ferme",
      "description": "Sledujte jehňata, zdraví stáda, vlnu a produkci masa s Ma Petite Ferme. Digitální nástroj pro chovatele ovcí, který zjednodušuje každodenní řízení farmy.",
      "h1": "Spravujte stádo ovcí chytře",
      "intro": "Ma Petite Ferme shromažďuje veškerá data o vašich ovcích – od jehněčí sezóny až po stříhání – na jednom přehledném místě. Snižte ztráty, zlepšete zdraví zvířat a zvyšte rentabilitu vaší ovčí farmy.",
      "bullets": [
        "Zaznamenejte každé jehněčí obahnění a sledujte novorozená jehňata",
        "Plánujte očkování a léčby pro celé stádo snadno a přehledně",
        "Analyzujte užitkovost vlny a masa u každého zvířete zvlášť"
      ]
    }
  },
  "bovins": {
    "fr": {
      "title": "Ma Petite Ferme – Gestion Bovins Lait & Viande",
      "description": "Gérez vos vaches laitières et allaitantes avec Ma Petite Ferme : suivi des vêlages, santé du troupeau, traçabilité et production laitière en un seul outil.",
      "h1": "Élevage bovin simplifié avec Ma Petite Ferme",
      "intro": "Ma Petite Ferme centralise toutes les données de votre troupeau bovin, du vêlage à la commercialisation. Suivez la production laitière, la santé animale et la traçabilité réglementaire sans effort.",
      "bullets": [
        "Enregistrez chaque vêlage et suivez la courbe de lactation",
        "Alertes santé personnalisées pour chaque vache du troupeau",
        "Traçabilité complète conforme aux exigences françaises"
      ]
    },
    "en": {
      "title": "Ma Petite Ferme – Cattle & Dairy Herd Management",
      "description": "Track calving, milk production and herd health with Ma Petite Ferme. Built for dairy and beef cattle farmers who need accurate records and full traceability.",
      "h1": "Smarter cattle management starts here",
      "intro": "Ma Petite Ferme gives cattle breeders a clear view of every animal, from first calving to market. Monitor milk yields, health events and compliance records all in one place.",
      "bullets": [
        "Log calvings and track individual lactation curves easily",
        "Automated health alerts for each cow in your herd",
        "Full traceability records ready for farm inspections"
      ]
    },
    "es": {
      "title": "Ma Petite Ferme – Gestión de Ganado Vacuno",
      "description": "Controla partos, producción de leche y sanidad del rebaño con Ma Petite Ferme. La solución ideal para ganaderos de vacuno de leche y carne en España.",
      "h1": "Gestiona tu ganadería bovina con facilidad",
      "intro": "Ma Petite Ferme pone toda la información de tu rebaño bovino al alcance de la mano, desde el parto hasta la venta. Optimiza la producción lechera, controla la sanidad y cumple con la trazabilidad oficial.",
      "bullets": [
        "Registra partos y controla la curva de lactación individual",
        "Alertas sanitarias automáticas para cada vaca del rebaño",
        "Trazabilidad completa adaptada a la normativa española"
      ]
    },
    "it": {
      "title": "Ma Petite Ferme – Gestione Bovini da Latte e Carne",
      "description": "Monitora parti, produzione di latte e salute della mandria con Ma Petite Ferme. Lo strumento completo per allevatori di bovini da latte e da carne in Italia.",
      "h1": "Alleva bovini meglio con Ma Petite Ferme",
      "intro": "Ma Petite Ferme raccoglie in un unico strumento tutti i dati del tuo allevamento bovino, dai parti alla commercializzazione. Controlla la produzione lattea, la salute degli animali e la tracciabilità normativa.",
      "bullets": [
        "Registra ogni parto e monitora le curve di lattazione",
        "Avvisi sanitari automatici per ogni capo della mandria",
        "Tracciabilità completa conforme alle normative italiane"
      ]
    },
    "de": {
      "title": "Ma Petite Ferme – Rinderhaltung & Milchvieh verwalten",
      "description": "Kalbungen, Milchleistung und Herdengesundheit im Griff: Ma Petite Ferme ist die Lösung für Milchvieh- und Fleischrindbetriebe mit lückenloser Rückverfolgbarkeit.",
      "h1": "Rinderhaltung einfach digital verwalten",
      "intro": "Ma Petite Ferme bündelt alle Herdendaten Ihres Rinderbetriebs – von der Kalbung bis zum Verkauf. Behalten Sie Milchleistung, Tiergesundheit und gesetzliche Kennzeichnungspflichten stets im Blick.",
      "bullets": [
        "Kalbungen erfassen und Laktationskurven je Tier auswerten",
        "Automatische Gesundheitswarnungen für jede Kuh der Herde",
        "Lückenlose Rückverfolgbarkeit für HIT und Behördenkontrollen"
      ]
    },
    "nl": {
      "title": "Ma Petite Ferme – Beheer voor Melk- en Vleesvee",
      "description": "Volg afkalvingen, melkproductie en diergezondheid met Ma Petite Ferme. Dé oplossing voor melkvee- en vleesveebedrijven die grip willen op hun kudde.",
      "h1": "Rundveebeheer slim geregeld met Ma Petite Ferme",
      "intro": "Ma Petite Ferme brengt alle kuddegegevens van uw rundveebedrijf samen op één plek, van afkalving tot afvoer. Monitor melkproductie, diergezondheid en traceerbaarheid zonder papierwerk.",
      "bullets": [
        "Registreer afkalvingen en volg individuele lactatiecurves",
        "Automatische gezondheidswaarschuwingen per koe in de kudde",
        "Volledige traceerbaarheid conform I&R-regelgeving"
      ]
    },
    "sv": {
      "title": "Ma Petite Ferme – Hantera Mjölk- och Köttboskap",
      "description": "Spåra kalvningar, mjölkproduktion och besättningens hälsa med Ma Petite Ferme. Det enkla verktyget för svenska nöt- och mjölkbönder med full spårbarhet.",
      "h1": "Effektivt nötkreaturshantering med Ma Petite Ferme",
      "intro": "Ma Petite Ferme samlar alla uppgifter om din nötkreatursbesättning på ett ställe, från kalvning till försäljning. Följ mjölkproduktion, djurhälsa och märkningskrav utan krångel.",
      "bullets": [
        "Registrera kalvningar och följ individuella laktationskurvor",
        "Automatiska hälsovarningar för varje ko i besättningen",
        "Komplett spårbarhet anpassad till svenska djurjournalkrav"
      ]
    },
    "da": {
      "title": "Ma Petite Ferme – Kvæg- og Malkekvægsstyring",
      "description": "Styr kælvninger, mælkeproduktion og besætningens sundhed med Ma Petite Ferme. Det rette værktøj for danske kvæg- og malkekvægsproducenter med fuld sporbarhed.",
      "h1": "Kvægstyring gjort nemt med Ma Petite Ferme",
      "intro": "Ma Petite Ferme samler alle data om din kvægbesætning ét sted, fra kælvning til afsætning. Hold styr på mælkeydelse, dyresundhed og CHR-krav uden besvær.",
      "bullets": [
        "Registrer kælvninger og følg individuelle laktationskurver",
        "Automatiske sundhedsadvarsler for hver ko i besætningen",
        "Fuld sporbarhed tilpasset danske CHR-indberetningskrav"
      ]
    },
    "bg": {
      "title": "Ma Petite Ferme – Управление на Говеда и Млечни Крави",
      "description": "Проследявайте отелвания, млекодобив и здраве на стадото с Ma Petite Ferme. Идеалното решение за фермери, отглеждащи млечни и месодайни говеда в България.",
      "h1": "Лесно управление на говеда с Ma Petite Ferme",
      "intro": "Ma Petite Ferme обединява всички данни за вашето говедовъдство на едно място, от отелването до продажбата. Контролирайте млекодобива, здравето на животните и проследимостта без усилие.",
      "bullets": [
        "Записвайте отелвания и следете лактационните криви на кравите",
        "Автоматични здравни известия за всяко животно в стадото",
        "Пълна проследимост съгласно българските ветеринарни изисквания"
      ]
    },
    "el": {
      "title": "Ma Petite Ferme – Διαχείριση Βοοειδών & Γαλακτοπαραγωγής",
      "description": "Παρακολουθήστε τοκετούς, γαλακτοπαραγωγή και υγεία αγέλης με Ma Petite Ferme. Η ιδανική λύση για κτηνοτρόφους βοοειδών γάλακτος και κρέατος στην Ελλάδα.",
      "h1": "Έξυπνη διαχείριση βοοειδών με Ma Petite Ferme",
      "intro": "Η Ma Petite Ferme συγκεντρώνει όλα τα δεδομένα της αγέλης σας σε ένα εργαλείο, από τον τοκετό μέχρι την πώληση. Παρακολουθήστε γαλακτοπαραγωγή, υγεία ζώων και ιχνηλασιμότητα χωρίς κόπο.",
      "bullets": [
        "Καταγράψτε τοκετούς και παρακολουθήστε καμπύλες γαλακτοπαραγωγής",
        "Αυτόματες ειδοποιήσεις υγείας για κάθε αγελάδα της αγέλης",
        "Πλήρης ιχνηλασιμότητα σύμφωνα με ελληνικές κτηνιατρικές απαιτήσεις"
      ]
    },
    "hr": {
      "title": "Ma Petite Ferme – Upravljanje Govedarstvom i Mlječnim Kravama",
      "description": "Pratite teljenja, mliječnost i zdravlje stada s Ma Petite Ferme. Idealno rješenje za uzgajivače goveda mlijeka i mesa u Hrvatskoj s potpunom sljedivošću.",
      "h1": "Jednostavno govedarstvo uz Ma Petite Ferme",
      "intro": "Ma Petite Ferme objedinjuje sve podatke vašeg govedarskog gospodarstva na jednom mjestu, od teljenja do prodaje. Pratite mliječnost, zdravlje životinja i zakonsku sljedivost bez napora.",
      "bullets": [
        "Bilježite teljenja i pratite laktacijske krivulje svake krave",
        "Automatska zdravstvena upozorenja za svaku kravu u stadu",
        "Potpuna sljedivost sukladna hrvatskim veterinarskim propisima"
      ]
    },
    "et": {
      "title": "Ma Petite Ferme – Veisekasvatuse ja Piimatootmise Haldus",
      "description": "Jälgi poegimisi, piimatoodangut ja karja tervist Ma Petite Ferme'iga. Parim lahendus piima- ja lihaveis­kasvatajatele täieliku jälgitavusega Eestis.",
      "h1": "Tark veisekasvatus Ma Petite Ferme'iga",
      "intro": "Ma Petite Ferme koondab kõik teie veisekasvatuse andmed ühte kohta, poegimisest müügini. Jälgige piimatoodangut, loomade tervist ja registreerimisnõudeid vaevata.",
      "bullets": [
        "Registreeri poegimised ja jälgi iga lehma laktatsioonigraafikut",
        "Automaatsed tervishoiuhoiatused igale karjas olevale lehmale",
        "Täielik jälgitavus vastavalt Eesti veterinaarregistri nõuetele"
      ]
    },
    "fi": {
      "title": "Ma Petite Ferme – Nautakarjan ja Lypsykarjan Hallinta",
      "description": "Seuraa poikimisia, maidontuotantoa ja karjan terveyttä Ma Petite Ferme -ohjelmistolla. Täydellinen ratkaisu suomalaisille lypsykarja- ja lihanautatilallisille.",
      "h1": "Nautakarjan hallinta helpottuu Ma Petite Ferme'llä",
      "intro": "Ma Petite Ferme kokoaa kaikki nautakarjatilasi tiedot yhteen paikkaan, poikimisesta teurastukseen. Seuraa maitomääriä, eläinten terveyttä ja merkintävaatimuksia vaivattomasti.",
      "bullets": [
        "Kirjaa poikimiset ja seuraa yksilöllisiä laktaatiokäyriä",
        "Automaattiset terveyshälytykset jokaiselle karjan lehmälle",
        "Täydellinen jäljitettävyys Suomen nautarekisterin vaatimusten mukaan"
      ]
    },
    "hu": {
      "title": "Ma Petite Ferme – Szarvasmarha-tenyésztés és Tejtermés",
      "description": "Kövesse nyomon az elléseket, a tejtermelést és az állomány egészségét a Ma Petite Ferme segítségével. Az ideális megoldás magyarországi tej- és húsmarha-tenyésztők számára.",
      "h1": "Okos szarvasmarha-tenyésztés Ma Petite Ferme-mel",
      "intro": "A Ma Petite Ferme egy helyen gyűjti össze szarvasmarha-gazdasága összes adatát, az elléstől az értékesítésig. Kövesse a tejtermelést, az állategészségügyet és a nyomonkövethetőségi kötelezettségeket könnyedén.",
      "bullets": [
        "Rögzítse az elléseket és kövesse az egyedi laktációs görbéket",
        "Automatikus egészségügyi figyelmeztetések minden tehén számára",
        "Teljes nyomonkövethetőség a magyar ENAR-előírásoknak megfelelően"
      ]
    },
    "lv": {
      "title": "Ma Petite Ferme – Liellopu Audzēšanas un Piensaimniecības Vadība",
      "description": "Sekojiet atnešanām, piena ražošanai un ganāmpulka veselībai ar Ma Petite Ferme. Ideāls risinājums Latvijas piena un gaļas liellopu audzētājiem.",
      "h1": "Viedā liellopu audzēšana ar Ma Petite Ferme",
      "intro": "Ma Petite Ferme apvieno visus jūsu liellopu saimniecības datus vienā vietā, no atnešanās līdz pārdošanai. Sekojiet piena ražošanai, dzīvnieku veselībai un izsekojamības prasībām bez piepūles.",
      "bullets": [
        "Reģistrējiet atnešanās un sekojiet individuālajām laktācijas līknēm",
        "Automātiski veselības brīdinājumi katrai govij ganāmpulkā",
        "Pilnīga izsekojamība atbilstoši Latvijas veterinārajām prasībām"
      ]
    },
    "lt": {
      "title": "Ma Petite Ferme – Galvijų Ūkio ir Pieno Gamybos Valdymas",
      "description": "Sekite apsiveršiavimus, pieno gamybą ir bandos sveikatą su Ma Petite Ferme. Puikus sprendimas Lietuvos pieno ir mėsos galvijų augintojams su visu atsekamumu.",
      "h1": "Išmanus galvijų valdymas su Ma Petite Ferme",
      "intro": "Ma Petite Ferme surenka visus jūsų galvijų ūkio duomenis vienoje vietoje, nuo apsiveršiavimo iki pardavimo. Stebėkite pieno gamybą, gyvūnų sveikatą ir ženklinimo reikalavimus be vargo.",
      "bullets": [
        "Registruokite apsiveršiavimus ir sekite individualias laktacijos kreives",
        "Automatiniai sveikatos įspėjimai kiekvienai bandos karvei",
        "Visiškas atsekamumas pagal Lietuvos galvijų registro reikalavimus"
      ]
    },
    "pl": {
      "title": "Ma Petite Ferme – Zarządzanie Bydłem Mlecznym i Mięsnym",
      "description": "Śledź wycielenia, produkcję mleka i zdrowie stada z Ma Petite Ferme. Idealne rozwiązanie dla polskich hodowców bydła mlecznego i mięsnego z pełną identyfikacją.",
      "h1": "Nowoczesna hodowla bydła z Ma Petite Ferme",
      "intro": "Ma Petite Ferme gromadzi wszystkie dane Twojego gospodarstwa bydlęcego w jednym miejscu, od wycielenia po sprzedaż. Monitoruj mleczność, zdrowie zwierząt i wymagania IRZ bez zbędnej biurokracji.",
      "bullets": [
        "Rejestruj wycielenia i śledź krzywe laktacji każdej krowy",
        "Automatyczne alerty zdrowotne dla każdej krowy w stadzie",
        "Pełna identyfikacja i rejestracja zgodna z wymogami IRZ"
      ]
    },
    "pt": {
      "title": "Ma Petite Ferme – Gestão de Bovinos de Leite e Carne",
      "description": "Controle partos, produção de leite e saúde do rebanho com Ma Petite Ferme. A solução completa para criadores portugueses de bovinos leiteiros e de corte.",
      "h1": "Gestão bovina simplificada com Ma Petite Ferme",
      "intro": "Ma Petite Ferme centraliza todos os dados da sua exploração bovina num único lugar, do parto à comercialização. Acompanhe a produção leiteira, a saúde animal e a rastreabilidade obrigatória sem esforço.",
      "bullets": [
        "Registe partos e acompanhe curvas de lactação individuais",
        "Alertas de saúde automáticos para cada vaca do rebanho",
        "Rastreabilidade completa conforme as normas SNIRB portuguesas"
      ]
    },
    "ro": {
      "title": "Ma Petite Ferme – Gestionarea Bovinelor de Lapte și Carne",
      "description": "Urmăriți fătările, producția de lapte și sănătatea efectivului cu Ma Petite Ferme. Soluția ideală pentru crescătorii români de bovine de lapte și carne cu trasabilitate completă.",
      "h1": "Creșteți bovine mai eficient cu Ma Petite Ferme",
      "intro": "Ma Petite Ferme centralizează toate datele fermei dumneavoastră bovine într-un singur loc, de la fătare până la vânzare. Monitorizați producția de lapte, sănătatea animalelor și cerințele de trasabilitate fără efort.",
      "bullets": [
        "Înregistrați fătările și urmăriți curbele de lactație individuale",
        "Alerte de sănătate automate pentru fiecare vacă din efectiv",
        "Trasabilitate completă conform reglementărilor ANSVSA din România"
      ]
    },
    "sk": {
      "title": "Ma Petite Ferme – Chov Hovädzieho Dobytka a Mliekárstvo",
      "description": "Sledujte otelenia, produkciu mlieka a zdravie stáda s Ma Petite Ferme. Ideálne riešenie pre slovenských chovateľov dojníc a mäsového dobytka s úplnou sledovateľnosťou.",
      "h1": "Chov hovädzieho dobytka ľahko s Ma Petite Ferme",
      "intro": "Ma Petite Ferme zhromažďuje všetky údaje vášho chovu hovädzieho dobytka na jednom mieste, od otelenia po predaj. Sledujte dojivosť, zdravie zvierat a zákonné požiadavky na označovanie bez námahy.",
      "bullets": [
        "Zaznamenávajte otelenia a sledujte individuálne laktačné krivky",
        "Automatické zdravotné upozornenia pre každú kravu v stáde",
        "Úplná sledovateľnosť v súlade so slovenskými veterinárnymi predpismi"
      ]
    },
    "sl": {
      "title": "Ma Petite Ferme – Reja Govedi in Upravljanje Mlečnih Krav",
      "description": "Sledite telitvam, prireji mleka in zdravju črede z Ma Petite Ferme. Popolna rešitev za slovenske rejce govedi za mleko in meso s popolno sledljivostjo.",
      "h1": "Pametna reja govedi z Ma Petite Ferme",
      "intro": "Ma Petite Ferme zbira vse podatke vašega govedorejskega gospodarstva na enem mestu, od telitve do prodaje. Spremljajte prirejo mleka, zdravje živali in zakonske zahteve brez napora.",
      "bullets": [
        "Beležite telitve in spremljajte individualne laktacijske krivulje",
        "Samodejná zdravstvena opozorila za vsako kravo v čredi",
        "Popolna sledljivost v skladu s slovensko veterinarsko zakonodajo"
      ]
    },
    "cs": {
      "title": "Ma Petite Ferme – Chov Skotu a Správa Dojnic",
      "description": "Sledujte otelení, produkci mléka a zdraví stáda s Ma Petite Ferme. Ideální řešení pro české chovatele dojnic a masného skotu s kompletní sledovatelností.",
      "h1": "Chov skotu snadno s Ma Petite Ferme",
      "intro": "Ma Petite Ferme shromažďuje veškerá data vašeho chovu skotu na jednom místě, od otelení po prodej. Sledujte dojivost, zdraví zvířat a zákonné požadavky na označování bez zbytečné administrativy.",
      "bullets": [
        "Zaznamenávejte otelení a sledujte individuální laktační křivky",
        "Automatická zdravotní upozornění pro každou krávu ve stádě",
        "Kompletní sledovatelnost dle požadavků českého ústředního registru"
      ]
    }
  },
  "porcs": {
    "fr": {
      "title": "Élevage porcin simplifié | Ma Petite Ferme",
      "description": "Gérez vos lots, maternités et croissance porcine depuis une seule application. Ma Petite Ferme optimise votre élevage de porcs à chaque étape.",
      "h1": "Pilotez votre élevage porcin avec précision",
      "intro": "Ma Petite Ferme centralise le suivi de vos truies, portées et bandes de porcs charcutiers en un outil intuitif. Gagnez du temps sur les tâches administratives et concentrez-vous sur la performance de votre élevage.",
      "bullets": [
        "Suivez chaque mise bas et taille de portée facilement",
        "Gérez vos bandes et rotations de cases automatiquement",
        "Optimisez la consommation d'aliments par lot de porcs"
      ]
    },
    "en": {
      "title": "Pig Farm Management Software | Ma Petite Ferme",
      "description": "Track farrowing, batch growth, and feed efficiency for your swine herd. Ma Petite Ferme helps pig farmers manage every production stage with ease.",
      "h1": "Smarter swine herd management made simple",
      "intro": "Ma Petite Ferme gives pig farmers a clear overview of every batch, from farrowing to finishing, all in one place. Monitor sow performance, litter records, and feed conversion without the paperwork.",
      "bullets": [
        "Record farrowing events and litter sizes instantly",
        "Track batch weight gain and daily growth rates",
        "Monitor feed conversion ratios across all pig groups"
      ]
    },
    "es": {
      "title": "Software para granjas porcinas | Ma Petite Ferme",
      "description": "Controla lotes, partos y crecimiento de tus cerdos desde una sola plataforma. Ma Petite Ferme mejora la rentabilidad de tu explotación porcina.",
      "h1": "Gestión porcina eficiente en tu granja",
      "intro": "Ma Petite Ferme te permite llevar un seguimiento completo de cerdas, lechones y lotes de engorde sin complicaciones. Toma decisiones basadas en datos reales para mejorar los resultados productivos de tu granja.",
      "bullets": [
        "Registra partos y tamaño de camadas al instante",
        "Controla el crecimiento diario de cada lote porcino",
        "Optimiza el consumo de pienso por grupo de animales"
      ]
    },
    "it": {
      "title": "Gestione allevamento suini | Ma Petite Ferme",
      "description": "Monitora partorienti, lotti e accrescimento dei tuoi suini in un'unica app. Ma Petite Ferme è il software ideale per gli allevatori di maiali italiani.",
      "h1": "Alleva suini con dati sempre sotto controllo",
      "intro": "Ma Petite Ferme semplifica la gestione delle scrofe, dei lattoni e dei lotti da ingrasso in un'unica piattaforma intuitiva. Riduci il lavoro burocratico e migliora l'efficienza alimentare del tuo allevamento.",
      "bullets": [
        "Registra ogni parto e il numero di suinetti nati",
        "Monitora l'accrescimento giornaliero per ogni lotto",
        "Controlla gli indici di conversione alimentare dei suini"
      ]
    },
    "de": {
      "title": "Schweinehaltung effizient verwalten | Ma Petite Ferme",
      "description": "Ferkelwürfe, Partien und Futterverwertung Ihrer Schweine einfach im Blick. Ma Petite Ferme unterstützt Schweinehalter bei jedem Produktionsschritt.",
      "h1": "Schweinehaltung digital und effizient steuern",
      "intro": "Ma Petite Ferme bietet Schweinehaltern eine zentrale Übersicht über alle Sauen, Würfe und Mastpartien – ohne lästigen Papierkram. Verfolgen Sie Tageszunahmen, Futterverbräuche und Belegungspläne auf einen Blick.",
      "bullets": [
        "Ferkelereignisse und Wurfgrößen sekundenschnell erfassen",
        "Tageszunahmen und Gewichtsentwicklung je Partie verfolgen",
        "Futterverwertung über alle Schweinegruppen optimieren"
      ]
    },
    "nl": {
      "title": "Varkenshouderij software | Ma Petite Ferme",
      "description": "Beheer worpen, koppels en voerverbruik van uw varkens in één overzichtelijke app. Ma Petite Ferme helpt varkenshouders slimmer produceren.",
      "h1": "Uw varkenshouderij slim en overzichtelijk beheren",
      "intro": "Ma Petite Ferme brengt alle informatie over uw zeugen, biggen en vleesvarkens samen in één platform. Volg groei, voerefficiëntie en worpregistraties zonder extra administratieve last.",
      "bullets": [
        "Registreer worpen en toomgrootte direct na het werpen",
        "Bewaak dagelijkse groei per koppel vleesvarkens",
        "Optimaliseer voerverbruik en voederconversie per groep"
      ]
    },
    "sv": {
      "title": "Grisuppfödning i en app | Ma Petite Ferme",
      "description": "Håll koll på grisgruppers tillväxt, grisningar och foderåtgång med Ma Petite Ferme. Smart mjukvara för svenska grisproducenter som vill ha bättre kontroll.",
      "h1": "Enklare grisproduktion med digital kontroll",
      "intro": "Ma Petite Ferme samlar all information om suggor, smågrisar och slaktgrisar på ett ställe. Följ tillväxt, grisningsresultat och fodereffektivitet utan onödig administration.",
      "bullets": [
        "Registrera grisningar och kullstorlekar direkt i appen",
        "Följ daglig tillväxt för varje grupp slaktgrisar",
        "Optimera foderåtgång och foderkonvertering per omgång"
      ]
    },
    "da": {
      "title": "Svineproduktion nemt styret | Ma Petite Ferme",
      "description": "Styr faringer, hold og foderforbrug for dine svin med Ma Petite Ferme. Få det fulde overblik over din svineproduktion i én brugervenlig løsning.",
      "h1": "Overblik over hele din svineproduktion",
      "intro": "Ma Petite Ferme giver svineproducenter et samlet overblik over søer, pattegrise og slagtesvin i én platform. Følg tilvækst, faringshyppighed og fodereffektivitet uden tung administration.",
      "bullets": [
        "Registrer faringer og kuldstørrelser hurtigt og nemt",
        "Følg daglig tilvækst for hvert hold slagtesvin",
        "Optimer foderforbrug og foderkonvertering på tværs af hold"
      ]
    },
    "bg": {
      "title": "Управление на свинеферма | Ma Petite Ferme",
      "description": "Следете опрасвания, партиди и фуражен прием на свинете си с Ma Petite Ferme. Оптимизирайте производителността на вашата свинеферма лесно и бързо.",
      "h1": "Дигитален контрол върху вашата свинеферма",
      "intro": "Ma Petite Ferme обединява данните за свинемайките, прасетата и угоителните партиди в една интуитивна платформа. Следете растежа, ефективността на фуража и опрасванията без излишна документация.",
      "bullets": [
        "Записвайте опрасвания и размер на прасилото моментално",
        "Проследявайте дневния прираст на всяка угоителна партида",
        "Оптимизирайте консумацията на фураж по групи свине"
      ]
    },
    "el": {
      "title": "Διαχείριση χοιροτροφείου | Ma Petite Ferme",
      "description": "Παρακολουθείτε τοκετούς, παρτίδες και κατανάλωση ζωοτροφών για τους χοίρους σας. Το Ma Petite Ferme απλοποιεί τη διαχείριση της χοιροτροφικής σας εκμετάλλευσης.",
      "h1": "Έξυπνη διαχείριση χοιροτροφείου ψηφιακά",
      "intro": "Το Ma Petite Ferme συγκεντρώνει όλα τα δεδομένα για τις χοιρομητέρες, τα χοιρίδια και τις παρτίδες πάχυνσης σε μία πλατφόρμα. Παρακολουθείτε ανάπτυξη, αποτελεσματικότητα ζωοτροφών και τοκετούς χωρίς γραφειοκρατία.",
      "bullets": [
        "Καταγράψτε τοκετούς και μέγεθος γέννας άμεσα",
        "Παρακολουθείτε ημερήσια αύξηση βάρους ανά παρτίδα",
        "Βελτιστοποιείτε κατανάλωση ζωοτροφών ανά ομάδα χοίρων"
      ]
    },
    "hr": {
      "title": "Svinjogojstvo u jednoj aplikaciji | Ma Petite Ferme",
      "description": "Pratite prasenja, serije i potrošnju hrane za svinje s Ma Petite Ferme. Optimizirajte svoju svinjogojsku farmu uz jednostavan digitalni alat.",
      "h1": "Digitalno upravljanje vašom svinjogojskom farmom",
      "intro": "Ma Petite Ferme spaja sve podatke o krmačama, odojcima i serijama tova u jednu preglednu platformu. Pratite rast, konverziju hrane i prasenja bez nepotrebne papirologije.",
      "bullets": [
        "Zabilježite prasenja i veličine legla trenutačno",
        "Pratite dnevni prirast za svaku seriju tovnih svinja",
        "Optimizirajte potrošnju hrane po skupinama svinja"
      ]
    },
    "et": {
      "title": "Seakasvatuse haldus lihtsalt | Ma Petite Ferme",
      "description": "Jälgi põrsaste sünde, partiisid ja söödakulu oma seafarmis Ma Petite Ferme abil. Optimeeri seakasvatuse tulemuslikkust digitaalse tarkvaraga.",
      "h1": "Seafarmi haldus digitaalselt ja lihtsalt",
      "intro": "Ma Petite Ferme koondab emiste, põrsaste ja nuumamispartiide andmed ühele platvormile. Jälgi kasvu, söödaefektiivsust ja poegimisi ilma liigse paberitööta.",
      "bullets": [
        "Registreeri poegimised ja pesakonna suurused kohe",
        "Jälgi iga nuumamispartii päevast juurdekasvu",
        "Optimeeri söödakulu üle kõigi searühmade"
      ]
    },
    "fi": {
      "title": "Sikatilan hallinta helpoksi | Ma Petite Ferme",
      "description": "Seuraa porsimisia, eriä ja rehunkulutusta sikatilallasi Ma Petite Farmen avulla. Paranna sianlihaviljelyn tehokkuutta älykkäällä ohjelmistolla.",
      "h1": "Sikatilan seuranta ja hallinta digitaalisesti",
      "intro": "Ma Petite Ferme kokoaa emakkojen, porsaiden ja lihasikaerien tiedot yhteen selkeään järjestelmään. Seuraa kasvua, rehuhyötysuhteita ja porsimistuloksia ilman turhaa paperityötä.",
      "bullets": [
        "Kirjaa porsimistapahtumat ja pahnuekoot välittömästi",
        "Seuraa päiväkasvua jokaisessa lihasikaerässä",
        "Optimoi rehunkulutus kaikissa sikaryhmissä"
      ]
    },
    "hu": {
      "title": "Sertéstelep kezelése egyszerűen | Ma Petite Ferme",
      "description": "Kövesse elléseit, tételeit és takarmányfelhasználását a Ma Petite Ferme alkalmazással. Optimalizálja sertéstelepe hatékonyságát digitális eszközzel.",
      "h1": "Sertéstelep digitális irányítása egy helyen",
      "intro": "A Ma Petite Ferme egyetlen platformon gyűjti össze a kocák, malacok és hízósertés-tételek adatait. Kövesse a növekedést, a takarmányértékesítést és az ellési eredményeket felesleges adminisztráció nélkül.",
      "bullets": [
        "Rögzítse az elléseket és az alomlétszámot azonnal",
        "Kövesse nyomon az egyes hízótételek napi súlygyarapodását",
        "Optimalizálja a takarmányfelhasználást sertéscsoportonként"
      ]
    },
    "lv": {
      "title": "Cūkaudzēšanas pārvaldība | Ma Petite Ferme",
      "description": "Sekojiet atnešanās, partijām un barības patēriņam savā cūku fermā ar Ma Petite Ferme. Uzlabojiet cūkaudzēšanas efektivitāti ar vienkāršu digitālu rīku.",
      "h1": "Digitāla cūku fermas pārvaldība vienā vietā",
      "intro": "Ma Petite Ferme apvieno visu informāciju par sivēnmātēm, sivēniem un nobarošanas partijām vienā platformā. Sekojiet augšanai, barības konversijai un atnešanās rezultātiem bez liekas birokrātijas.",
      "bullets": [
        "Reģistrējiet atnešanās un metienu lielumu uzreiz",
        "Sekojiet katras nobarošanas partijas dienas pieaugumam",
        "Optimizējiet barības patēriņu visās cūku grupās"
      ]
    },
    "lt": {
      "title": "Kiaulių ūkio valdymas | Ma Petite Ferme",
      "description": "Sekite apsiveršiavimus, partijas ir pašarų sunaudojimą savo kiaulių ūkyje su Ma Petite Ferme. Padidinkite kiaulininkystės efektyvumą naudodami skaitmeninę programą.",
      "h1": "Kiaulių ūkio skaitmeninis valdymas lengvai",
      "intro": "Ma Petite Ferme sujungia visus duomenis apie paršavedės, paršelius ir penėjimo partijas vienoje platformoje. Stebėkite augimą, pašarų konversiją ir apsiveršiavimo rezultatus be bereikalingos administracijos.",
      "bullets": [
        "Registruokite apsiveršiavimus ir vados dydį akimirksniu",
        "Stebėkite kiekvienos penėjimo partijos dienos priesvorio augimą",
        "Optimizuokite pašarų sunaudojimą visose kiaulių grupėse"
      ]
    },
    "pl": {
      "title": "Zarządzanie hodowlą świń | Ma Petite Ferme",
      "description": "Śledź oproszenia, partie tuczników i zużycie paszy w swojej fermie z Ma Petite Ferme. Popraw wyniki produkcji trzody chlewnej dzięki inteligentnemu oprogramowaniu.",
      "h1": "Cyfrowe zarządzanie fermą trzody chlewnej",
      "intro": "Ma Petite Ferme gromadzi dane o lochach, prosiętach i partiach tuczników w jednej intuicyjnej platformie. Monitoruj przyrosty, efektywność paszową i wyniki oproszenia bez zbędnej papierkowej roboty.",
      "bullets": [
        "Rejestruj oproszenia i wielkość miotów natychmiast",
        "Śledź dzienne przyrosty każdej partii tuczników",
        "Optymalizuj zużycie paszy we wszystkich grupach świń"
      ]
    },
    "pt": {
      "title": "Gestão de suinocultura eficiente | Ma Petite Ferme",
      "description": "Controle parições, lotes e consumo de ração dos seus suínos com Ma Petite Ferme. Melhore a produtividade da sua granja com uma solução digital completa.",
      "h1": "Gestão completa da sua granja suinícola",
      "intro": "Ma Petite Ferme reúne todos os dados sobre matrizes, leitões e lotes de engorda numa plataforma intuitiva. Acompanhe o crescimento, a conversão alimentar e os resultados de parição sem burocracia.",
      "bullets": [
        "Registe parições e tamanho de leitegadas ao instante",
        "Acompanhe o ganho de peso diário por lote de suínos",
        "Otimize o consumo de ração em todos os grupos de animais"
      ]
    },
    "ro": {
      "title": "Gestionare fermă porcine | Ma Petite Ferme",
      "description": "Urmăriți fătările, loturile și consumul de furaje al porcilor cu Ma Petite Ferme. Îmbunătățiți eficiența fermei de porci cu un instrument digital simplu.",
      "h1": "Controlul digital al fermei de porci",
      "intro": "Ma Petite Ferme reunește datele despre scroafe, purcei și loturile la îngrășat într-o singură platformă intuitivă. Monitorizați creșterea, conversia furajelor și rezultatele fătărilor fără birocrație inutilă.",
      "bullets": [
        "Înregistrați fătările și mărimea aruncăturilor imediat",
        "Urmăriți sporul zilnic pentru fiecare lot de porci la îngrășat",
        "Optimizați consumul de furaje pe toate grupele de porci"
      ]
    },
    "sk": {
      "title": "Správa chovu ošípaných | Ma Petite Ferme",
      "description": "Sledujte prasenia, partie a spotrebu krmiva vo vašej farme s Ma Petite Ferme. Zlepšite výsledky chovu ošípaných pomocou intuitívneho digitálneho nástroja.",
      "h1": "Digitálna správa farmy ošípaných jednoducho",
      "intro": "Ma Petite Ferme spája údaje o prasnicách, seláčikoch a výkrmových partiách do jednej prehľadnej platformy. Sledujte prírastky, efektivitu krmiva a výsledky prasení bez zbytočnej administratívy.",
      "bullets": [
        "Zaznamenajte prasenia a veľkosť vrhu okamžite",
        "Sledujte denný prírastok každej výkrmovej partie",
        "Optimalizujte spotrebu krmiva vo všetkých skupinách ošípaných"
      ]
    },
    "sl": {
      "title": "Upravljanje reje prašičev | Ma Petite Ferme",
      "description": "Spremljajte prasitve, serije in porabo krme za prašiče z Ma Petite Ferme. Izboljšajte učinkovitost vaše prašičje farme z enostavnim digitalnim orodjem.",
      "h1": "Digitalno upravljanje prašičje farme enostavno",
      "intro": "Ma Petite Ferme zbira podatke o svinjah, pujsih in pitanskih serijah v eni intuitivni platformi. Spremljajte rast, konverzijo krme in rezultate prasitev brez odvečne administracije.",
      "bullets": [
        "Zabeležite prasitve in velikost gnezda takoj",
        "Spremljajte dnevni prirast vsake pitanske serije prašičev",
        "Optimizirajte porabo krme v vseh skupinah prašičev"
      ]
    },
    "cs": {
      "title": "Správa chovu prasat | Ma Petite Ferme",
      "description": "Sledujte prasení, partie a spotřebu krmiva ve vaší farmě s Ma Petite Ferme. Zvyšte efektivitu chovu prasat pomocí přehledného digitálního nástroje.",
      "h1": "Digitální správa prasečí farmy přehledně",
      "intro": "Ma Petite Ferme spojuje data o prasnicích, selátcích a výkrmových partiích do jedné intuitivní platformy. Sledujte přírůstky, efektivitu krmiva a výsledky prasení bez zbytečné administrativy.",
      "bullets": [
        "Zaznamenejte prasení a velikost vrhu okamžitě",
        "Sledujte denní přírůstek každé výkrmové partie prasat",
        "Optimalizujte spotřebu krmiva ve všech skupinách prasat"
      ]
    }
  },
  "lapins": {
    "fr": {
      "title": "Élevage de lapins simplifié | Ma Petite Ferme",
      "description": "Gérez vos cages, portées et cycles de reproduction avec Ma Petite Ferme. Suivez chaque lapin, optimisez vos mises bas et boostez votre rentabilité viande.",
      "h1": "Gérez votre élevage cunicole facilement",
      "intro": "Ma Petite Ferme centralise la gestion de vos lapins, de la mise bas à l'abattage. Suivez chaque cage, chaque portée et chaque saillie depuis une seule application.",
      "bullets": [
        "Planifiez les saillies et suivez chaque portée automatiquement",
        "Gérez vos cages et alertes de nettoyage en temps réel",
        "Analysez vos rendements viande par génération de lapins"
      ]
    },
    "en": {
      "title": "Rabbit Farm Management Software | Ma Petite Ferme",
      "description": "Track cages, litters, and breeding cycles effortlessly with Ma Petite Ferme. Maximise meat yields and keep your rabbitry running at peak efficiency.",
      "h1": "Smarter management for rabbit breeders",
      "intro": "Ma Petite Ferme gives rabbit breeders a complete toolkit to monitor every cage, litter, and breeding pair in one place. Stay on top of kindling dates, feed costs, and meat production with zero paperwork.",
      "bullets": [
        "Log kindling dates and track litter survival rates easily",
        "Schedule cage cleaning and health checks with smart alerts",
        "Monitor meat yield and profitability per breeding cycle"
      ]
    },
    "es": {
      "title": "Software para criadores de conejos | Ma Petite Ferme",
      "description": "Controla jaulas, camadas y ciclos reproductivos con Ma Petite Ferme. Mejora tus rendimientos de carne y lleva tu cunicultura al siguiente nivel.",
      "h1": "Cunicultura profesional desde tu móvil",
      "intro": "Ma Petite Ferme te permite registrar cada monta, camada y jaula desde una sola plataforma diseñada para cunicultores. Optimiza la producción cárnica y reduce pérdidas con alertas inteligentes.",
      "bullets": [
        "Registra montas y prevé fechas de parto automáticamente",
        "Controla el estado sanitario de cada jaula en tiempo real",
        "Compara rendimientos cárnicos por lote y ciclo productivo"
      ]
    },
    "it": {
      "title": "Software cunicolo professionale | Ma Petite Ferme",
      "description": "Gestisci gabbie, nidiate e cicli riproduttivi con Ma Petite Ferme. Ottimizza la produzione di carne e tieni traccia di ogni coniglio allevato.",
      "h1": "Alleva conigli con più controllo",
      "intro": "Ma Petite Ferme è la soluzione digitale pensata per i cunicoltori italiani che vogliono gestire gabbie, accoppiamenti e nidiate senza carta né confusione. Monitora la resa in carne e pianifica ogni ciclo riproduttivo con precisione.",
      "bullets": [
        "Pianifica accoppiamenti e parti con promemoria automatici",
        "Registra peso e accrescimento di ogni nidiata facilmente",
        "Calcola la redditività per ciclo e per capo macellato"
      ]
    },
    "de": {
      "title": "Kaninchenzucht effizient verwalten | Ma Petite Ferme",
      "description": "Käfige, Würfe und Deckzyklen im Blick behalten mit Ma Petite Ferme. Optimieren Sie Fleischproduktion und Zuchtplanung auf einer modernen Plattform.",
      "h1": "Professionelle Verwaltung für Kaninchenhalter",
      "intro": "Ma Petite Ferme hilft Kaninchenzüchtern, jeden Käfig, jeden Wurf und jeden Decktermin digital zu erfassen und auszuwerten. Reduzieren Sie Verluste, steigern Sie die Fleischausbeute und behalten Sie den Überblick über Ihren gesamten Bestand.",
      "bullets": [
        "Decktermine planen und Wurfzeitpunkte automatisch berechnen",
        "Käfigreinigung und Tiergesundheit per Alarm nie vergessen",
        "Fleischleistung und Rentabilität je Zuchtzyklus auswerten"
      ]
    },
    "nl": {
      "title": "Konijnenfokkerij beheren met Ma Petite Ferme",
      "description": "Houd kooien, nesten en dektijden bij met Ma Petite Ferme. Verhoog uw vleesopbrengst en stroomlijn uw konijnenhouderij zonder papierwerk.",
      "h1": "Slim beheer voor konijnenhouders",
      "intro": "Ma Petite Ferme biedt konijnenhouders één overzichtelijk platform voor het bijhouden van kooien, nesten en fokregistraties. Optimaliseer uw vleesproductie en plan dektijden met automatische herinneringen.",
      "bullets": [
        "Registreer dektijden en bereken werpdata automatisch",
        "Bewaak kooigezondheid met slimme reinigingsherinneringen",
        "Analyseer vleesopbrengst en kosten per fokronde"
      ]
    },
    "sv": {
      "title": "Skötsel av kaninuppfödning | Ma Petite Ferme",
      "description": "Hantera burar, kullar och parningstider smidigt med Ma Petite Ferme. Öka köttproduktionen och håll koll på din kaninbesättning med ett enkelt verktyg.",
      "h1": "Effektiv uppfödning av köttkaniner",
      "intro": "Ma Petite Ferme ger kaninuppfödare ett digitalt verktyg för att följa varje bur, kull och parning från en och samma plats. Planera slakt, förbättra tillväxt och spara tid med automatiska påminnelser.",
      "bullets": [
        "Planera parningar och beräkna kullningsdatum automatiskt",
        "Få påminnelser om rengöring och hälsokontroll per bur",
        "Följ köttutbyte och lönsamhet per uppfödningscykel"
      ]
    },
    "da": {
      "title": "Kaninopdræt uden besvær | Ma Petite Ferme",
      "description": "Styr bure, kuld og parringscyklusser nemt med Ma Petite Ferme. Optimer kødproduktionen og hold styr på hele din kaninbesætning ét sted.",
      "h1": "Bedre overblik over dit kaninhold",
      "intro": "Ma Petite Ferme samler alle oplysninger om dine kaniner – fra parring til slagtning – i én brugervenlig app. Hold styr på kuld, vægt og rengøring uden papirarbejde.",
      "bullets": [
        "Registrer parringer og få automatisk besked om kuldning",
        "Planlæg burrengøring og sundhedstjek med smarte alarmer",
        "Analyser kødudbytte og indtjening pr. opdrætscyklus"
      ]
    },
    "bg": {
      "title": "Софтуер за зайцевъдство | Ma Petite Ferme",
      "description": "Управлявайте клетки, котила и развъдни цикли с Ma Petite Ferme. Увеличете месодайността и следете всеки заек от раждането до продажбата.",
      "h1": "Лесно управление на зайцефермата",
      "intro": "Ma Petite Ferme предоставя на зайцевъдите цифров инструмент за проследяване на клетки, котила и чифтосвания от едно място. Оптимизирайте производството на месо и намалете загубите с автоматични напомняния.",
      "bullets": [
        "Планирайте чифтосвания и изчислявайте дати на раждане автоматично",
        "Следете здравето на клетките с умни известия за почистване",
        "Анализирайте рентабилността и месодайността по цикъл"
      ]
    },
    "el": {
      "title": "Λογισμικό κουνελοτροφίας | Ma Petite Ferme",
      "description": "Παρακολουθήστε κλουβιά, γέννες και αναπαραγωγικούς κύκλους με το Ma Petite Ferme. Βελτιώστε την παραγωγή κρέατος και οργανώστε την εκτροφή σας.",
      "h1": "Έξυπνη διαχείριση κουνελοτροφείου",
      "intro": "Το Ma Petite Ferme δίνει στους κουνελοτρόφους ένα ψηφιακό εργαλείο για την παρακολούθηση κλουβιών, γεννών και ζευγαρώματος από ένα σημείο. Μειώστε απώλειες και αυξήστε την απόδοση κρέατος με έξυπνες υπενθυμίσεις.",
      "bullets": [
        "Προγραμματίστε ζευγαρώματα και υπολογίστε ημερομηνίες γέννας",
        "Λάβετε ειδοποιήσεις καθαρισμού και υγείας ανά κλουβί",
        "Αναλύστε απόδοση κρέατος και κερδοφορία ανά κύκλο"
      ]
    },
    "hr": {
      "title": "Softver za uzgoj kunića | Ma Petite Ferme",
      "description": "Pratite kaveze, legla i cikluse razmnožavanja uz Ma Petite Ferme. Povećajte prinos mesa i optimizirajte svaki uzgojni ciklus bez papirnatih evidencija.",
      "h1": "Digitalni alat za uzgajivače kunića",
      "intro": "Ma Petite Ferme omogućuje uzgajivačima kunića praćenje svakog kaveza, legla i parenja na jednoj platformi. Smanjite gubitke i povećajte prinos mesa uz pametne podsjetnike i analize.",
      "bullets": [
        "Planirajte parenja i automatski izračunajte datum okota",
        "Primajte obavijesti o čišćenju kaveza i zdravstvenim pregledima",
        "Analizirajte prinos mesa i profitabilnost po uzgojnom ciklusu"
      ]
    },
    "et": {
      "title": "Küülikukasvatus lihtsaks | Ma Petite Ferme",
      "description": "Halda puurid, pesakonnad ja paaritustsüklid Ma Petite Ferme'iga. Suurenda lihatoodangut ja hoia kogu kari ülevaatlikult ühes kohas.",
      "h1": "Tark küülikukasvatuse haldamine",
      "intro": "Ma Petite Ferme koondab küülikukasvatajatele kõik puure, pesakondi ja paaritusi puudutavad andmed ühte rakendusse. Planeeri tapmisaegu, analüüsi lihatoodangut ja vähenda kadusid automaatsete meeldetuletustega.",
      "bullets": [
        "Planeeri paaritused ja arvuta pesakonna sünnikuupäevad automaatselt",
        "Saa meeldetuletusi puuri puhastamise ja tervisekontrolli kohta",
        "Analüüsi lihatoodangut ja tasuvust iga kasvatustsükli järel"
      ]
    },
    "fi": {
      "title": "Kaninkasvatus hallintaan | Ma Petite Ferme",
      "description": "Hallitse häkkejä, pentuja ja lisääntymissyklejä Ma Petite Ferme -ohjelmistolla. Maksimoi lihantuotanto ja pidä koko kaninkasvatuksesi järjestyksessä.",
      "h1": "Tehokas työkalu kaninkasvatukseen",
      "intro": "Ma Petite Ferme tarjoaa kaninkasvatajille digitaalisen ratkaisun häkkien, pentueiden ja paritusaikataulujen hallintaan yhdessä paikassa. Optimoi lihantuotanto, seuraa kasvua ja vähennä hävikkiä älykkäillä muistutuksilla.",
      "bullets": [
        "Suunnittele paritukset ja laske syntymäajankohdat automaattisesti",
        "Saat muistutukset häkkien puhdistuksesta ja terveystarkastuksista",
        "Analysoi lihantuotannon kannattavuus kasvatussykleittäin"
      ]
    },
    "hu": {
      "title": "Nyúltenyésztés egyszerűen | Ma Petite Ferme",
      "description": "Kezelje ketreceit, alomai és szaporodási ciklusait a Ma Petite Ferme segítségével. Növelje hústermelését és tartsa naprakészen nyúlállományát könnyedén.",
      "h1": "Okos nyúltenyésztés-irányítás",
      "intro": "A Ma Petite Ferme egyetlen platformon egyesíti a nyúltenyésztők számára fontos adatokat: ketrecek, almok, fedeztetések és hústermelési mutatók. Csökkentse a veszteségeket és optimalizálja tenyésztési ciklusait automatikus emlékeztetőkkel.",
      "bullets": [
        "Tervezze a fedeztetéseket és számítsa ki az ellési dátumokat automatikusan",
        "Ketrec-tisztítási és egészségügyi emlékeztetők egyetlen alkalmazásban",
        "Elemezze a hústermelési eredményeket és jövedelmezőséget ciklusonként"
      ]
    },
    "lv": {
      "title": "Trušu audzēšana viegli | Ma Petite Ferme",
      "description": "Pārvaldiet būrus, metienos un vairošanās ciklus ar Ma Petite Ferme. Uzlabojiet gaļas ražošanu un sekojiet katram trušam no dzimšanas līdz pārdošanai.",
      "h1": "Digitāls rīks trušu audzētājiem",
      "intro": "Ma Petite Ferme sniedz trušu audzētājiem pilnu pārskatu par būriem, metienam un pārošanās grafikiem vienā vietā. Samaziniet zudumus un palieliniet gaļas ražošanu ar viediem atgādinājumiem.",
      "bullets": [
        "Plānojiet pārošanos un automātiski aprēķiniet atnešanās datumus",
        "Saņemiet atgādinājumus par būru tīrīšanu un veselības pārbaudēm",
        "Analizējiet gaļas ražošanas rentabilitāti katrā audzēšanas ciklā"
      ]
    },
    "lt": {
      "title": "Triušių auginimas paprastai | Ma Petite Ferme",
      "description": "Valdykite narvelius, vadas ir veisimo ciklus su Ma Petite Ferme. Padidinkite mėsos gamybą ir sekite kiekvieną triušį nuo gimimo iki pardavimo.",
      "h1": "Išmanus triušių ūkio valdymas",
      "intro": "Ma Petite Ferme suteikia triušių augintojams skaitmeninę priemonę narvelių, vadų ir poravimosi tvarkaraščių valdymui vienoje vietoje. Sumažinkite nuostolius ir optimizuokite mėsos gamybą automatiniais priminimais.",
      "bullets": [
        "Planuokite poravimus ir automatiškai apskaičiuokite apsivadavimo datas",
        "Gaukite priminimus apie narvelių valymą ir sveikatos patikrinimus",
        "Analizuokite mėsos gamybos pelningumą kiekvienam veisimo ciklui"
      ]
    },
    "pl": {
      "title": "Zarządzanie hodowlą królików | Ma Petite Ferme",
      "description": "Zarządzaj klatkami, miotami i cyklami rozrodczymi z Ma Petite Ferme. Zwiększ produkcję mięsa i miej kontrolę nad całą hodowlą królików w jednym miejscu.",
      "h1": "Nowoczesne zarządzanie hodowlą królików",
      "intro": "Ma Petite Ferme to cyfrowe narzędzie dla hodowców królików, które łączy zarządzanie klatkami, miotami i kryciami w jednej prostej aplikacji. Optymalizuj produkcję mięsa, śledź wzrost i redukuj straty dzięki automatycznym przypomnieniom.",
      "bullets": [
        "Planuj krycia i automatycznie obliczaj daty wykoceń",
        "Otrzymuj powiadomienia o czyszczeniu klatek i kontrolach zdrowia",
        "Analizuj wydajność mięsną i rentowność każdego cyklu hodowlanego"
      ]
    },
    "pt": {
      "title": "Software para cunicultura | Ma Petite Ferme",
      "description": "Gerencie gaiolas, ninhadas e ciclos reprodutivos com Ma Petite Ferme. Aumente a produção de carne e acompanhe cada coelho do nascimento ao abate.",
      "h1": "Cunicultura organizada do início ao fim",
      "intro": "Ma Petite Ferme oferece aos cunicultores uma plataforma completa para gerir gaiolas, ninhadas e coberturas num só lugar. Otimize a produção de carne, reduza perdas e planeie cada ciclo com alertas automáticos.",
      "bullets": [
        "Planeie coberturas e calcule datas de parto automaticamente",
        "Receba alertas de limpeza e saúde por gaiola em tempo real",
        "Analise a rentabilidade e produção de carne por ciclo reprodutivo"
      ]
    },
    "ro": {
      "title": "Software pentru cuniculturi | Ma Petite Ferme",
      "description": "Gestionați cuști, fătări și cicluri de reproducere cu Ma Petite Ferme. Optimizați producția de carne și urmăriți fiecare iepure de la naștere până la vânzare.",
      "h1": "Gestionare modernă a crescătoriei de iepuri",
      "intro": "Ma Petite Ferme pune la dispoziția crescătorilor de iepuri un instrument digital pentru urmărirea cuștilor, fătărilor și împerecherilor dintr-o singură aplicație. Reduceți pierderile și creșteți producția de carne cu ajutorul alertelor automate.",
      "bullets": [
        "Planificați împerecherile și calculați automat datele de fătare",
        "Primiți notificări pentru curățarea cuștilor și controale sanitare",
        "Analizați rentabilitatea și producția de carne per ciclu de creștere"
      ]
    },
    "sk": {
      "title": "Správa chovu králikov | Ma Petite Ferme",
      "description": "Spravujte klietky, vrhy a reprodukčné cykly s Ma Petite Ferme. Zvýšte produkciu mäsa a majte prehľad o celom chove králikov na jednom mieste.",
      "h1": "Digitálne riadenie chovu králikov",
      "intro": "Ma Petite Ferme ponúka chovateľom králikov kompletný nástroj na evidenciu klietok, vrhov a krytí v jedinej aplikácii. Optimalizujte produkciu mäsa, sledujte rast zvierat a znížte straty vďaka automatickým upozorneniam.",
      "bullets": [
        "Plánujte krytia a automaticky vypočítajte dátumy vrhnutia",
        "Dostávajte upomienky na čistenie klietok a zdravotné kontroly",
        "Analyzujte produkciu mäsa a ziskovosť na každý chovný cyklus"
      ]
    },
    "sl": {
      "title": "Reja kuncev brez papirja | Ma Petite Ferme",
      "description": "Upravljajte kletke, legla in razmnoževalne cikle z Ma Petite Ferme. Povečajte pridelavo mesa in imejte pregled nad celotno rejo kuncev na enem mestu.",
      "h1": "Pametno upravljanje reje kuncev",
      "intro": "Ma Petite Ferme združuje vse podatke o kletkah, leglih in parjenjih v eni enostavni aplikaciji za rejce kuncev. Optimizirajte pridelavo mesa, zmanjšajte izgube in načrtujte vsak cikel z avtomatičnimi opomniki.",
      "bullets": [
        "Načrtujte paritve in samodejno izračunajte datum kotitve",
        "Prejemajte opomnik za čiščenje kletk in zdravstvene preglede",
        "Analizirajte pridelek mesa in dobičkonosnost na rejski cikel"
      ]
    },
    "cs": {
      "title": "Správa chovu králíků | Ma Petite Ferme",
      "description": "Spravujte klece, vrhy a reprodukční cykly s Ma Petite Ferme. Zvyšte produkci masa a mějte přehled o celém chovu králíků na jediném místě.",
      "h1": "Digitální evidence chovu králíků",
      "intro": "Ma Petite Ferme nabízí chovatelům králíků kompletní digitální nástroj pro evidenci klecí, vrhů a krytí v jedné přehledné aplikaci. Optimalizujte produkci masa, sledujte přírůstky a snižte ztráty díky automatickým upozorněním.",
      "bullets": [
        "Plánujte krytí a automaticky vypočítejte termíny vrhnutí",
        "Dostávejte připomínky na čištění klecí a veterinární kontroly",
        "Analyzujte produkci masa a ziskovost za každý chovný cyklus"
      ]
    }
  },
  "abeilles": {
    "fr": {
      "title": "Gestion ruches & apiculture | Ma Petite Ferme",
      "description": "Gérez vos ruches, suivez vos colonies et planifiez vos récoltes de miel avec Ma Petite Ferme. L'outil indispensable pour chaque apiculteur passionné.",
      "h1": "Votre rucher piloté avec précision",
      "intro": "Ma Petite Ferme vous accompagne dans chaque étape de la vie de votre rucher, de l'essaimage à la récolte du miel. Gardez le contrôle de vos colonies et anticipez les besoins de chaque ruche en toute simplicité.",
      "bullets": [
        "Suivi sanitaire ruche par ruche en temps réel",
        "Planifiez vos récoltes de miel avec précision",
        "Alertes essaimage et mortalité de colonie automatiques"
      ]
    },
    "en": {
      "title": "Beekeeping & Hive Management | Ma Petite Ferme",
      "description": "Track your hives, monitor colony health and schedule honey harvests effortlessly with Ma Petite Ferme. The smart tool built for modern beekeepers.",
      "h1": "Smart management for every apiary",
      "intro": "Ma Petite Ferme gives beekeepers a clear, real-time overview of every hive in their apiary, from colony strength to honey yield. Stay ahead of swarming season and keep your bees thriving all year round.",
      "bullets": [
        "Log inspections and queen status per hive",
        "Schedule and record honey harvests accurately",
        "Receive automatic alerts for swarming or colony loss"
      ]
    },
    "es": {
      "title": "Gestión de colmenas y apicultura | Ma Petite Ferme",
      "description": "Controla tus colmenas, el estado de tus colonias y la cosecha de miel con Ma Petite Ferme. La herramienta ideal para apicultores profesionales y aficionados.",
      "h1": "Tu colmenar siempre bajo control",
      "intro": "Ma Petite Ferme centraliza toda la información de tu colmenar para que nunca pierdas el hilo de ninguna colonia. Desde la inspección de la reina hasta la planificación de la mielada, tendrás todo al alcance de la mano.",
      "bullets": [
        "Registro de inspecciones colmena por colmena",
        "Planifica tus cosechas de miel fácilmente",
        "Alertas automáticas ante enjambrazón o pérdidas"
      ]
    },
    "it": {
      "title": "Gestione apiario e alveari | Ma Petite Ferme",
      "description": "Monitora i tuoi alveari, la salute delle colonie e le raccolte di miele con Ma Petite Ferme. Lo strumento pensato per ogni apicoltore moderno.",
      "h1": "Il tuo apiario sempre sotto controllo",
      "intro": "Ma Petite Ferme ti offre una visione completa e in tempo reale di ogni alveare del tuo apiario, dalla forza della colonia alla resa in miele. Anticipa la sciamatura e mantieni le tue api in salute durante tutto l'anno.",
      "bullets": [
        "Registra ispezioni e stato della regina alveare",
        "Pianifica le raccolte di miele con precisione",
        "Ricevi avvisi automatici per sciamatura o perdite"
      ]
    },
    "de": {
      "title": "Bienenhaltung & Beuten verwalten | Ma Petite Ferme",
      "description": "Verwalten Sie Ihre Bienenvölker, überwachen Sie die Gesundheit Ihrer Beuten und planen Sie Ihre Honigernte mit Ma Petite Ferme. Ideal für Imker jeder Erfahrungsstufe.",
      "h1": "Imkerei professionell und einfach verwalten",
      "intro": "Ma Petite Ferme bietet Imkern einen zentralen Überblick über jeden Bienenstock – von der Königin bis zur Honigernte. Erkennen Sie Schwarmstimmung frühzeitig und halten Sie Ihre Völker das ganze Jahr über gesund.",
      "bullets": [
        "Kontrollen und Königinnenstatus je Beute erfassen",
        "Honigernte termingenau planen und dokumentieren",
        "Automatische Schwarm- und Völkerverlust-Warnungen"
      ]
    },
    "nl": {
      "title": "Bijenhouderij & kastbeheer | Ma Petite Ferme",
      "description": "Beheer uw bijenkasten, volg de volksgezondheid en plan uw honingoogst met Ma Petite Ferme. Dé tool voor iedere imker die het overzicht wil bewaren.",
      "h1": "Uw bijenstal slim en overzichtelijk beheerd",
      "intro": "Ma Petite Ferme biedt imkers een compleet overzicht van elke bijenkast, van de conditie van het volk tot de honingopbrengst. Anticipeer op zwermgedrag en houd uw bijen het hele jaar gezond.",
      "bullets": [
        "Inspecties en koninginnenstatus per kast vastleggen",
        "Honingoogst nauwkeurig plannen en registreren",
        "Automatische meldingen bij zwermen of volksverlies"
      ]
    },
    "sv": {
      "title": "Biodling & kuphantering | Ma Petite Ferme",
      "description": "Håll koll på dina bikupor, kolonihälsa och honungsskörd med Ma Petite Ferme. Det smarta verktyget för dig som tar din biodling på allvar.",
      "h1": "Sköt ditt bigård enkelt och smart",
      "intro": "Ma Petite Ferme ger dig en tydlig överblick över varje bikupa i din bigård, från drottningens status till honung­skördens planering. Förebygg svärmning och håll dina kolonier friska hela säsongen.",
      "bullets": [
        "Registrera inspektioner och drottningsstatus per kupa",
        "Planera och dokumentera din honungsskörd noggrant",
        "Automatiska varningar vid svärmning eller kolonidöd"
      ]
    },
    "da": {
      "title": "Biavl & bistalde styring | Ma Petite Ferme",
      "description": "Administrér dine bistader, følg kolonisundheden og planlæg din honninghøst med Ma Petite Ferme. Det ideelle redskab for enhver biavler.",
      "h1": "Styr din biavl professionelt og nemt",
      "intro": "Ma Petite Ferme giver biavlere et samlet overblik over hvert bistadie, fra dronningens tilstand til honningudbytte. Forebyg sværmning og hold dine kolonier sunde hele sæsonen.",
      "bullets": [
        "Log tilsyn og dronningestatus per bistade",
        "Planlæg og dokumentér honninghøsten præcist",
        "Automatiske advarsler ved sværmning eller kolonisvigt"
      ]
    },
    "bg": {
      "title": "Пчеларство и управление на кошери | Ma Petite Ferme",
      "description": "Управлявайте кошерите си, следете здравето на колониите и планирайте медосбора с Ma Petite Ferme. Идеалният инструмент за всеки пчелар.",
      "h1": "Управлявайте пчелина си с лекота",
      "intro": "Ma Petite Ferme ви дава пълен преглед на всеки кошер в пчелина, от силата на колонията до прогнозата за медосбора. Предотвратете роенето и пазете пчелите си здрави през цялата година.",
      "bullets": [
        "Записвайте прегледи и статус на майката по кошер",
        "Планирайте медосбора точно и навременно",
        "Автоматични сигнали при роене или загуба на колония"
      ]
    },
    "el": {
      "title": "Μελισσοκομία & διαχείριση κυψελών | Ma Petite Ferme",
      "description": "Παρακολουθήστε τις κυψέλες, την υγεία των αποικιών και τον τρύγο μελιού με το Ma Petite Ferme. Το εργαλείο που κάθε μελισσοκόμος χρειάζεται.",
      "h1": "Διαχειριστείτε το μελισσοκομείο σας εύκολα",
      "intro": "Το Ma Petite Ferme σας δίνει πλήρη εποπτεία κάθε κυψέλης στο μελισσοκομείο σας, από τη δύναμη της αποικίας έως την απόδοση μελιού. Προλαμβάνετε τη σμηνουργία και διατηρείτε τις μέλισσές σας υγιείς όλο το χρόνο.",
      "bullets": [
        "Καταγράφετε επιθεωρήσεις και κατάσταση βασίλισσας",
        "Σχεδιάστε τη συγκομιδή μελιού με ακρίβεια",
        "Αυτόματες ειδοποιήσεις για σμηνουργία ή απώλεια"
      ]
    },
    "hr": {
      "title": "Pčelarstvo i upravljanje košnicama | Ma Petite Ferme",
      "description": "Pratite košnice, zdravlje kolonija i planiranje berbe meda s Ma Petite Ferme. Idealan alat za svakog pčelara koji želi potpuni pregled pčelinjaka.",
      "h1": "Vaš pčelinjak pod potpunom kontrolom",
      "intro": "Ma Petite Ferme nudi pčelarima jasan pregled svake košnice, od snage kolonije do prinosa meda. Preduhitrite rojenje i osigurajte zdravlje pčela tijekom cijele sezone.",
      "bullets": [
        "Bilježite preglede i status matice po košnici",
        "Planirajte i dokumentirajte berbu meda precizno",
        "Automatska upozorenja pri rojenju ili gubitku kolonije"
      ]
    },
    "et": {
      "title": "Mesindus ja tarupidamine | Ma Petite Ferme",
      "description": "Halda oma tarusid, jälgi koloonia tervist ja planeeri meesaaki Ma Petite Ferme'iga. Parim tööriist igale mesindajale täieliku ülevaate saamiseks.",
      "h1": "Halda oma mesila tõhusalt ja lihtsalt",
      "intro": "Ma Petite Ferme annab mesindajatele täieliku ülevaate igast tarust – emamesilase seisundist kuni meesaagi planeerimiseni. Ennetage parvlemist ja hoidke oma mesilaspered aastaringselt tervena.",
      "bullets": [
        "Salvesta ülevaatused ja emamesilase staatus taru kaupa",
        "Planeeri meesaak täpselt ja dokumenteeri tulemused",
        "Automaatsed hoiatused parvlemise või pere hukkumise korral"
      ]
    },
    "fi": {
      "title": "Mehiläishoito & pesien hallinta | Ma Petite Ferme",
      "description": "Hallinnoi pesiäsi, seuraa yhdyskuntien terveyttä ja suunnittele hunajasato Ma Petite Ferme -palvelulla. Täydellinen työkalu jokaiselle mehiläistarhurille.",
      "h1": "Hallitse mehiläistarhasi älykkäästi",
      "intro": "Ma Petite Ferme antaa mehiläistarhureille selkeän kokonaiskuvan jokaisesta pesästä kuningattaren tilasta hunajasadon suunnitteluun. Ennakoi parveilu ja pidä yhdyskuntasi terveinä ympäri vuoden.",
      "bullets": [
        "Kirjaa tarkastukset ja kuningattaren tila pesäkohtaisesti",
        "Suunnittele ja dokumentoi hunajasato tarkasti",
        "Automaattiset hälytykset parveilusta tai yhdyskunnan menetyksestä"
      ]
    },
    "hu": {
      "title": "Méhészet és kaptárkezelés | Ma Petite Ferme",
      "description": "Kövesse nyomon kaptárait, a rajok egészségét és tervezze meg a mézszezonát a Ma Petite Ferme segítségével. A tökéletes eszköz minden méhésznek.",
      "h1": "Kezelje méhészetét egyszerűen és hatékonyan",
      "intro": "A Ma Petite Ferme átfogó képet nyújt minden kaptárról, a királynő állapotától a méztermelés tervezéséig. Előzze meg a rajzást, és tartsa egészségesen a méhcsaládjait egész évben.",
      "bullets": [
        "Rögzítse az ellenőrzéseket és a királynő állapotát kaptáronként",
        "Tervezze meg pontosan a mézszezon betakarítását",
        "Automatikus riasztás rajzás vagy rajpusztulás esetén"
      ]
    },
    "lv": {
      "title": "Biškopība un stropu pārvaldība | Ma Petite Ferme",
      "description": "Pārvaldiet savus stropus, uzraugiet koloniju veselību un plānojiet medus ražu ar Ma Petite Ferme. Ideāls rīks ikvienam biškopim.",
      "h1": "Pārvaldiet savu biškopību vienkārši",
      "intro": "Ma Petite Ferme sniedz biškopjiem pilnīgu pārskatu par katru stropu – no mātes statusa līdz medus ražas plānošanai. Novērsiet spiešanu un uzturiet savas bišu saimes veselīgas visu gadu.",
      "bullets": [
        "Reģistrējiet pārbaudes un mātes statusu katram kropam",
        "Precīzi plānojiet un dokumentējiet medus ražu",
        "Automātiski brīdinājumi par spiešanu vai saimes zaudēšanu"
      ]
    },
    "lt": {
      "title": "Bitininkystė ir avilio valdymas | Ma Petite Ferme",
      "description": "Valdykite savo avilius, stebėkite šeimų sveikatą ir planuokite medaus derliaus nuėmimą su Ma Petite Ferme. Puikus įrankis kiekvienam bitininkui.",
      "h1": "Valdykite bitinyną paprastai ir efektyviai",
      "intro": "Ma Petite Ferme suteikia bitininkams išsamią kiekvieno avilio apžvalgą – nuo motinėlės būklės iki medaus derliaus planavimo. Užkirkite kelią spiečiavimui ir laikykite bičių šeimas sveikas ištisus metus.",
      "bullets": [
        "Fiksuokite patikrinimus ir motinėlės būklę kiekvienam aviliui",
        "Tiksliai planuokite ir dokumentuokite medaus derliaus nuėmimą",
        "Automatiniai įspėjimai apie spiečiavimą ar šeimos praradimą"
      ]
    },
    "pl": {
      "title": "Pszczelarstwo i zarządzanie ulami | Ma Petite Ferme",
      "description": "Zarządzaj ulami, monitoruj zdrowie rodzin pszczelich i planuj zbiory miodu z Ma Petite Ferme. Najlepsze narzędzie dla każdego pszczelarza.",
      "h1": "Zarządzaj pasieką profesjonalnie i prosto",
      "intro": "Ma Petite Ferme zapewnia pszczelarzom pełny przegląd każdego ula – od kondycji rodziny po planowanie zbiorów miodu. Zapobiegaj rojeniu i dbaj o zdrowie pszczół przez cały rok.",
      "bullets": [
        "Rejestruj przeglądy i stan matki pszczelej w każdym ulu",
        "Planuj i dokumentuj zbiory miodu z dużą precyzją",
        "Automatyczne alerty przy rojeniu lub utracie rodziny"
      ]
    },
    "pt": {
      "title": "Apicultura e gestão de colmeias | Ma Petite Ferme",
      "description": "Gerencie suas colmeias, acompanhe a saúde das colônias e planeje a colheita de mel com Ma Petite Ferme. A ferramenta essencial para todo apicultor.",
      "h1": "Gerencie seu apiário com precisão",
      "intro": "Ma Petite Ferme oferece aos apicultores uma visão completa de cada colmeia, desde o estado da rainha até o planejamento da colheita de mel. Antecipe a enxameação e mantenha suas abelhas saudáveis durante todo o ano.",
      "bullets": [
        "Registre inspeções e estado da rainha por colmeia",
        "Planeje e documente a colheita de mel precisamente",
        "Alertas automáticos de enxameação ou perda de colônia"
      ]
    },
    "ro": {
      "title": "Apicultură și gestionarea stupilor | Ma Petite Ferme",
      "description": "Gestionați stupii, monitorizați sănătatea coloniilor și planificați recolta de miere cu Ma Petite Ferme. Instrumentul ideal pentru orice apicultor.",
      "h1": "Gestionați stupina cu precizie și ușurință",
      "intro": "Ma Petite Ferme oferă apicultorilor o imagine de ansamblu completă asupra fiecărui stup, de la puterea coloniei până la planificarea recoltei de miere. Anticipați roirea și mențineți albinele sănătoase tot anul.",
      "bullets": [
        "Înregistrați inspecțiile și starea mătcii per stup",
        "Planificați și documentați recolta de miere cu precizie",
        "Alerte automate la roire sau pierderea unei colonii"
      ]
    },
    "sk": {
      "title": "Včelárstvo a správa úľov | Ma Petite Ferme",
      "description": "Spravujte úle, sledujte zdravie včelstiev a plánujte medovú úrodu s Ma Petite Ferme. Ideálny nástroj pre každého včelára, ktorý chce mať prehľad.",
      "h1": "Spravujte včelín jednoducho a efektívne",
      "intro": "Ma Petite Ferme poskytuje včelárom úplný prehľad o každom úli, od stavu matky až po plánovanie medovej úrody. Predchádzajte rojeniu a udržujte včelstvá zdravé po celý rok.",
      "bullets": [
        "Zaznamenávajte prehliadky a stav matky pri každom úli",
        "Plánujte a dokumentujte medovú úrodu presne",
        "Automatické upozornenia pri rojení alebo strate včelstva"
      ]
    },
    "sl": {
      "title": "Čebelarstvo in upravljanje panjev | Ma Petite Ferme",
      "description": "Upravljajte panje, spremljajte zdravje čebeljih družin in načrtujte medeno žetev z Ma Petite Ferme. Popolno orodje za vsakega čebelarja.",
      "h1": "Upravljajte čebelnjak preprosto in učinkovito",
      "intro": "Ma Petite Ferme čebelarjem zagotavlja celovit pregled vsakega panja, od stanja matice do načrtovanja medene žetve. Preprečite rojenje in ohranjajte čebelje družine zdrave vse leto.",
      "bullets": [
        "Beležite preglede in stanje matice za vsak panj",
        "Natančno načrtujte in dokumentirajte medeno žetev",
        "Samodejna opozorila ob rojenju ali izgubi čebelje družine"
      ]
    },
    "cs": {
      "title": "Včelařství a správa úlů | Ma Petite Ferme",
      "description": "Spravujte úly, sledujte zdraví včelstev a plánujte medovou úrodu s Ma Petite Ferme. Ideální nástroj pro každého včelaře, který chce mít vše pod kontrolou.",
      "h1": "Spravujte včelín jednoduše a efektivně",
      "intro": "Ma Petite Ferme poskytuje včelařům kompletní přehled o každém úlu, od stavu matky až po plánování medové úrody. Předcházejte rojení a udržujte včelstva zdravá po celý rok.",
      "bullets": [
        "Zaznamenávejte prohlídky a stav matky u každého úlu",
        "Plánujte a dokumentujte medovou úrodu přesně",
        "Automatická upozornění při rojení nebo ztrátě včelstva"
      ]
    }
  }
};

export const FR_BREEDING_SLUGS = SPECIES_KEYS.map((k) => SPECIES_SLUGS[k].fr);

export function speciesPath(key, lang) {
  const map = SPECIES_SLUGS[key] || {};
  const slug = map[lang] || map[DEFAULT_LANG];
  return `${langPrefix(lang)}/${slug}`;
}

export function speciesData(key, lang) {
  const c = SPECIES_CONTENT[key] || {};
  return c[lang] || c[DEFAULT_LANG] || {};
}

export function buildSpeciesAlternates(key, origin) {
  const o = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  const alts = LOCALES.map((l) => ({ hreflang: l.hreflang, href: `${o}${speciesPath(key, l.code)}` }));
  alts.push({ hreflang: "x-default", href: `${o}${speciesPath(key, DEFAULT_LANG)}` });
  return alts;
}
